import Vue from "vue";
import MarketingService from "@/services/MarketingService";
import { router } from "@/router";
import { authenticationService } from "@/services/AuthenticationService";
import moment from "moment";
import store from "@/store";
import _ from "lodash";
import { CLIENT_NAME } from "@/helper/Role";

function initialState() {
  return {
    OffersList: [],
    tempOfferData: null,
    OffersVoucherList: [],
    offerFor: null,
    CinemaSettings: {
      cine_sell_fnb_in_boxoffice: null
    },
    selectedOffers: {},
    offersObject: {
      cinema_id: null,
      screen_id: null,
      seat_type_id: null, // sst_id: null,
      movie_details_id: null,
      show_date_time: null,
      show_actual_date_time: null,
      tt_id: null
    },
    promocode: "",
    voucherCode: "",
    offersPosFlags: {
      isPosOffersShow: false,
      isOfferItemRemoved: false
    },
    offerVerificationList: [],
    offerCategoriesList: [],
    offerPrice: 0,
    // OfferAppl

    CardNumber: null,
    isOfferAppliedV2: false,
    voucherComment: "",
    openVoucher: {
      isOpenVoucher: "Y",
      isComplementary: "Y",
      ticketTypeId: null,
      seatTypeArray: []
    },
    openVoucherSeatTypeArray: [],
    seatTypeOpenVoucher: [
      {
        sst_seat_type: "Regular",
        tt_name: "Adult",
        totalTicketType: 5,
        SinglePrice: 52.5,
        tt_id: 1,
        sst_id: 1,
        selectedRateCard: 5,
        totalOfferPrice: 262.5
      },
      {
        sst_seat_type: "Gold",
        tt_name: "Adult",
        totalTicketType: 5,
        SinglePrice: 52.5,
        tt_id: 1,
        sst_id: 1,
        selectedRateCard: 5,
        totalOfferPrice: 262.5
      },

    ],
    RemainingCashRefundOffer: 0
  };
}

function checkItemAvailable(item) {
  if(item && item.hasOwnProperty('availableInVendorRates') && item.availableInVendorRates == 'N') {
    return false
  } else {
    return true
  }
}

const state = initialState();

const mutations = {
  SET_REMAINING_PRICE: (state, payload) => {
    state.RemainingCashRefundOffer = payload
  },
  RESET_REMAINING_PRICE: (state, payload) => {
    state.RemainingCashRefundOffer = 0
  },
  SET_TEMP_OFFER_DATA: (state, payload) => {
    state.tempOfferData = payload
  },
  SET_OPEN_VOUCHER_INFO: (state, payload) => {
    state.openVoucher.isOpenVoucher = payload.isOpenVoucher ? "Y" : "N";
    state.openVoucher.isComplementary = payload.isComplementary ? "Y" : "N";
    state.openVoucher.ticketTypeId = payload.ticketTypeId || null;
    state.openVoucher.totalGrossAmount = payload.totalGrossAmount || 0;
    state.openVoucherSeatTypeArray = payload.totalTicketType || [];
    state.openVoucherSeatTypeArray.forEach(x => {
      x["VoucherAmount"] = 0;
    });
  },
  INCREASE_TICKET_TYPE_COUNT: (state, payload) => {
    // state.openVoucherSeatTypeArray[payload].selected += 1;
    // state.openVoucherSeatTypeArray[payload].VoucherAmount =
    //   state.openVoucherSeatTypeArray[payload].selected *
    //   state.openVoucherSeatTypeArray[payload].SinglePrice;
    let count = 0;
    let total_amount = 0;

    state.openVoucherSeatTypeArray.map(z => {
      if (z.selected < z.totalTicketType && count == 0) {
        z.selected = z.selected + 1;
        z.VoucherAmount = z.selected * z.SinglePrice;
        count++;
      }
      total_amount = total_amount + z.VoucherAmount;
    });
    console.log("total_amount", total_amount);
    console.log("openVoucherSeatTypeArray", state.openVoucherSeatTypeArray);
    state.offerPrice = +parseFloat(total_amount).toFixed(2);
    if (count == 0) {
      Vue.toasted.show(
        "You have selected maximum number of Complimentary Tickets"
      );
    }
  },
  DECREASE_TICKET_TYPE_COUNT: (state, payload) => {
    state.openVoucherSeatTypeArray[payload].selected -= 1;
    state.openVoucherSeatTypeArray[payload].VoucherAmount =
      state.openVoucherSeatTypeArray[payload].selected *
      state.openVoucherSeatTypeArray[payload].SinglePrice;
  },
  SET_CARD_NUMBER: (state, payload) => {
    if (payload.title && payload.title.length > 0) {
      state.CardNumber = payload.title;
    } else {
      state.CardNumber = null;
    }
  },
  ON_RESET_OFFERS_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  ON_RESET_SELECTET_OFFER_AND_PRICE: (state, payload) => {
    state.offerPrice = 0;
    state.RemainingCashRefundOffer = 0;
    state.selectedOffers = {};
    state.promocode = "";
    state.tempOfferData = null;
  },
  SET_OFFERS_EMPTY: (state, payload) => {
    state.OffersList = [];
    state.OffersVoucherList = [];
  },
  RESET_VOUCHER_CODE: (state, payload) => {
    state.voucherCode = "";
  },
  RESET_COMMENT: (state, payload) => {
    state.voucherComment = "";
  },
  SET_OFFERS_LIST: (state, payload) => {
    state.OffersList = payload;

    state.OffersList.map(x => {
      if (String(x.offer_type_id) === "6") {
        let list =
          x["booking_user_category_id"] &&
            x["booking_user_category_id"].length > 0
            ? x["booking_user_category_id"].split(", ")
            : [];
        x["booking_user_category_id"] = "";
        list.map(z => {
          let a = state.offerCategoriesList.filter(
            y => String(z) === String(y.buc_id)
          );
          if (a.length > 0) {
            x["booking_user_category_id"] +=
              x["booking_user_category_id"].length > 0
                ? `, ${a[0].buc_category_name}`
                : `${a[0].buc_category_name}`;
          }
        });
      }
    });
  },
  SET_OFFERS_VOUCHERS_LIST: (state, payload) => {
    state.OffersVoucherList = _.sortBy(payload, ["order"]);

    // state.OffersList.map((x) => {
    //     if (String(x.offer_type_id) === '6') {
    //         let list = x['booking_user_category_id'] && x['booking_user_category_id'].length > 0 ? x['booking_user_category_id'].split(', ') : [];
    //         x['booking_user_category_id'] = '';
    //         list.map((z) => {
    //             let a = state.offerCategoriesList.filter((y) => String(z) === String(y.buc_id));
    //             if (a.length > 0) {
    //                 x['booking_user_category_id'] += x['booking_user_category_id'].length > 0 ? `, ${a[0].buc_category_name}` : `${a[0].buc_category_name}`
    //             }
    //         });
    //     }
    // })
  },
  SET_CINEMA_SETTING: (state, payload) => {
    state.CinemaSettings = {
      ...payload
    };
  },
  SET_OFFERS_VERIFICATION_LIST: (state, payload) => {
    state.offerVerificationList = payload;
  },
  SET_OFFERS_CATEGORIES_LIST: (state, payload) => {
    state.offerCategoriesList = payload;
  },
  SET_OFFERS_STATES: (state, payload) => {
    switch (payload.name) {
      case "isCinema":
        state.offersObject.cinema_id = payload.id;
        break;
      case "isMovie":
        state.offersObject.movie_details_id = payload.id;
        break;
      case "isScreen":
        state.offersObject.screen_id = payload.id;
        break;
      case "isSeatType":
        state.offersObject.seat_type_id = payload.id;
        break;
      case "isMovie_isScreen_isShowTime":
        state.offersObject.screen_id = payload.screen_id;
        state.offersObject.movie_details_id = payload.movie_details_id;
        state.offersObject.show_date_time = payload.show_date_time;
        state.offersObject.show_actual_date_time = payload.show_actual_date_time;
        break;
      case "isTicketType":
        state.offersObject.tt_id = payload.id;
        break;
      default:
        console.log("PosOffer: Sorry! we are enable to set value.");
    }
  },
  SET_ENTER_PROMO_CODE: (state, payload) => {
    switch (payload.name) {
      case "enterPromoCode":
        store.dispatch("onSetAndSendLog", {
          action: `ENTERTED ${payload.event.target.value} promocode`,
          page_name: "",
          api_name: window.location.hash
        });
        state.promocode = payload.event.target.value;

        break;
      default:
        console.log("FilmCollection :Sorry, we are enable to set value.");
    }
  },
  SET_VOUCHER_AMOUNT: (state, payload) => {
    const { index, event } = payload;
    state.openVoucherSeatTypeArray[index].VoucherAmount = parseFloat(
      event.target.value
    );
    console.log(
      "state.openVoucherSeatTypeArray[index].VoucherAmount",
      state.openVoucherSeatTypeArray[index].VoucherAmount
    );
  },
  SET_ENTER_VOUCHER_CODE: (state, payload) => {
    console.log('payload SET_ENTER_VOUCHER_CODE', payload);
    switch (payload.name) {
      case "enterVoucherCode":
        store.dispatch("onSetAndSendLog", {
          action: `ENTERTED ${payload.event.target.value} voucher code`,
          page_name: "",
          api_name: window.location.hash
        });
        state.voucherCode = payload.event.target.value;

        break;
      default:
        console.log("Voucher :Sorry, we are enable to set value.");
    }
  },
  SET_VOUCHER_COMMENT: (state, payload) => {
    state.voucherComment = payload;
  },
  //// POS
  SET_POS_OFFERS_FLAGS: (state, payload) => {
    switch (payload.name) {
      case "isPosOffersShow":
        state.offersPosFlags.isPosOffersShow = payload.value;
        console.log(
          "state.offersPosFlags.isPosOffersShow :",
          state.offersPosFlags.isPosOffersShow
        );
        break;
      default:
        console.log("FilmCollection :Sorry, we are enable to set value.");
    }
  },
  SET_FLAG_ShowViewOffers: (state, payload) => {
    state.offersPosFlags.isPosOffersShow = payload;
  },
  SET_SELECTED_OFFERS: (state, { event, offer, offerFor }) => {
    // state.selectedOffers = payload
    store.dispatch("resetMeritCardDetails");
    if (offer.offer_title) {
      store.dispatch("onSetAndSendLog", {
        action: `Selected ${offer.offer_title} offer for ${offerFor} `,
        page_name: "",
        api_name: window.location.hash
      });
    }
    state.selectedOffers = offer;
    state.offerFor = offerFor;
    state.isOfferAppliedV2 = true;
    console.log('offerFor', offerFor)
  },
  SET_SELECTED_VOUCHER: (state, payload) => {
    state.selectedOffers = payload.offer;
    state.offerFor = payload.offerFor;
    state.isOfferAppliedV2 = true;
  },
  CALCULATE_OFFER_PRICE: (state, payload) => {
    console.log("CALCULATE_OFFER_PRICE payload", payload);
    // state.offerApplied = payload;
    if (payload.offer_applicable_on_gross_amount == "Y") {
      if (payload.offer_type_id == 6) {
        if (payload.pcs_offer_value) {
          if (payload.pcs_offer_value_is_percentage == "N") {
            state.offerPrice = parseFloat(payload.pcs_offer_value);
          } else if (payload.pcs_offer_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(store.getters.TOTAL_AMOUNT) *
                parseInt(payload.pcs_offer_value)) /
              100;
          }
        }
      } else if (payload.offer_type_id == 4) {
        if (store.getters.TOTAL_AMOUNT > payload.cco_min_ticket_amount) {
          if (payload.cco_offer_value) {
            if (payload.cco_offer_value_is_percentage == "N") {
              state.offerPrice = parseFloat(payload.cco_offer_value);
            } else if (payload.cco_offer_value_is_percentage == "Y") {
              state.offerPrice =
                (parseFloat(store.getters.TOTAL_AMOUNT) *
                  parseInt(payload.cco_offer_value)) /
                100;
            }
            if (state.offerPrice > payload.cco_max_discount_amount) {
              state.offerPrice = payload.cco_max_discount_amount;
            }
          }
        } else {
          Vue.toasted.show(
            `Minimum amount should be greater than ${payload.cco_min_ticket_amount}`
          );
        }
      } else if (payload.offer_type_id == 5) {
        if (payload.bo_offer_value) {
          if (payload.bo_offer_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(store.getters.TOTAL_AMOUNT) *
                parseInt(payload.bo_offer_value)) /
              100;
          } else {
            state.offerPrice = payload.bo_offer_value;
          }
        }
      } else {
        if (payload.oc_get_free_ticket) {
          const ticket_price = parseFloat(
            store.getters.SELECTED_SEATS[0].seat_price
          );
          let maxNumberOfApplicableTickets;
          let totalNumberOfApplicableTickets = Math.floor(
            store.getters.SELECTED_SEATS.length /
            (payload.oc_buy_no_of_ticket + payload.oc_get_free_ticket)
          );
          totalNumberOfApplicableTickets *= payload.oc_get_free_ticket;
          if (
            totalNumberOfApplicableTickets >
            parseInt(payload.oc_max_no_of_ticket_per_transaction)
          ) {
            maxNumberOfApplicableTickets = parseInt(
              payload.oc_max_no_of_ticket_per_transaction
            );
          } else {
            maxNumberOfApplicableTickets = totalNumberOfApplicableTickets;
          }
          state.offerPrice = ticket_price * maxNumberOfApplicableTickets;
          // state.offerPrice =
          //   parseFloat(store.getters.SELECTED_SEATS[0].seat_price) *
          //   payload.oc_get_free_ticket;
        } else if (payload.oc_discount_value) {
          if (payload.oc_discount_value_is_percentage == "N") {
            let totalNumberOfApplicableTickets = Math.floor(
              store.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket
            );
            console.log(
              "totalNumberOfApplicableTickets :>> ",
              totalNumberOfApplicableTickets
            );
            state.offerPrice =
              parseFloat(payload.oc_discount_value) *
              totalNumberOfApplicableTickets;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            let totalNumberOfApplicableTickets = Math.floor(
              store.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket
            );
            state.offerPrice =
              ((parseFloat(store.getters.TOTAL_AMOUNT) *
                parseInt(payload.oc_discount_value)) /
                100) *
              totalNumberOfApplicableTickets;
          }
        }
      }
    }
    //For Net Amount
    else if (payload.offer_applicable_on_net_amount == "Y") {
      if (payload.offer_type_id == 6) {
        if (payload.pcs_offer_value) {
          if (payload.pcs_offer_value_is_percentage == "N") {
            state.offerPrice = parseFloat(payload.pcs_offer_value);
          } else if (payload.pcs_offer_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(store.getters.NET_AMOUNT) *
                parseInt(payload.pcs_offer_value)) /
              100;
          }
        }
      } else if (payload.offer_type_id == 4) {
        if (store.getters.NET_AMOUNT > payload.cco_min_ticket_amount) {
          if (payload.cco_offer_value) {
            if (payload.cco_offer_value_is_percentage == "N") {
              state.offerPrice = parseFloat(payload.cco_offer_value);
            } else if (payload.cco_offer_value_is_percentage == "Y") {
              state.offerPrice =
                (parseFloat(store.getters.NET_AMOUNT) *
                  parseInt(payload.cco_offer_value)) /
                100;
            }
            if (state.offerPrice > payload.cco_max_discount_amount) {
              state.offerPrice = payload.cco_max_discount_amount;
            }
          }
        } else {
          Vue.toasted.show(
            `Minimum amount should be greater than ${payload.cco_min_ticket_amount}`
          );
        }
      } else {
        if (payload.oc_get_free_ticket) {
          state.offerPrice =
            parseFloat(store.getters.SELECTED_SEATS[0].seat_net_price) *
            payload.oc_get_free_ticket;
        } else if (payload.oc_discount_value) {
          if (payload.oc_discount_value_is_percentage == "N") {
            state.offerPrice = parseFloat(payload.oc_discount_value);
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(store.getters.NET_AMOUNT) *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        }
      }
    }
    // Ensuring offer amount is not greater than max discount amount
    if (
      payload.oc_max_discount_amount &&
      state.offerPrice > payload.oc_max_discount_amount &&
      payload.oc_discount_value_is_percentage == "N"
    ) {
      state.offerPrice = payload.oc_max_discount_amount;
    }
    if (
      payload.oc_max_discount_amount &&
      payload.oc_discount_value_is_percentage == "Y"
    ) {
      let totalNumberOfApplicableTickets = Math.floor(
        store.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket
      );
      let maxDiscountPercentage =
        totalNumberOfApplicableTickets * payload.oc_discount_value;
      console.log("maxDiscountPercentage final:>> ", maxDiscountPercentage);
      if (maxDiscountPercentage > payload.oc_max_discount_amount) {
        if (payload.offer_applicable_on_net_amount == "Y") {
          state.offerPrice =
            (parseFloat(store.getters.NET_AMOUNT) *
              parseInt(payload.oc_max_discount_amount)) /
            100;
        } else if (payload.offer_applicable_on_gross_amount == "Y") {
          state.offerPrice =
            (parseFloat(store.getters.TOTAL_AMOUNT) *
              parseInt(payload.oc_max_discount_amount)) /
            100;
        }
      }
    }
    if (
      payload.oc_max_discount_amount &&
      state.offerPrice > payload.oc_max_discount_amount
    ) {
      state.offerPrice = payload.oc_max_discount_amount;
    }
    store.dispatch("onSetAndSendLog", {
      action: `Selected offer value : ${state.offerPrice} `,
      page_name: "POS BOOKING",
      api_name: window.location.hash
    });
  },
  SET_OFFER_VOUCHER_PRICE: (state, payload) => {
    state.offerPrice = payload.TotalOfferPrice;

    store.dispatch("onSetAndSendLog", {
      action: `Selected voucher offer value : ${state.offerPrice} `,
      page_name: "pos booking",
      api_name: window.location.hash
    });
  },
  CALCULATE_OFFER_VOUCHER_PRICE: (state, offer) => {
    //NOT USING ANYMORE ## USING SET_OFFER_VOUCHER_PRICE

    if (offer.voucher_redeem_on_gross === "Y") {
      if (offer.is_voucher_type_value == "Y") {
        if (offer.voucher_is_percentage == "Y") {
          state.offerPrice =
            (parseFloat(store.getters.TOTAL_AMOUNT) *
              parseInt(offer.voucher_amount)) /
            100;
        } else if (offer.voucher_is_percentage == "N") {
          state.offerPrice = parseFloat(offer.voucher_amount);
        }
      } else if (
        offer.voucher_buy_no_of_ticket &&
        offer.voucher_get_free_ticket
      ) {
        state.offerPrice =
          parseFloat(store.getters.SELECTED_SEATS[0].seat_price) *
          parseInt(offer.voucher_get_free_ticket);
      }
    } else if (offer.voucher_redeem_on_net === "Y") {
      if (offer.is_voucher_type_value == "Y") {
        if (offer.voucher_is_percentage == "Y") {
          state.offerPrice =
            (parseFloat(store.getters.NET_AMOUNT) *
              parseInt(offer.voucher_amount)) /
            100;
        } else if (offer.voucher_is_percentage == "N") {
          state.offerPrice = parseFloat(offer.voucher_amount);
        }
      } else if (
        offer.voucher_buy_no_of_ticket &&
        offer.voucher_get_free_ticket
      ) {
        state.offerPrice =
          parseFloat(store.getters.SELECTED_SEATS[0].seat_net_price) *
          parseInt(offer.voucher_get_free_ticket);
      }
    }
    store.dispatch("onSetAndSendLog", {
      action: `Selected voucher offer value : ${state.offerPrice} `,
      page_name: "pos booking",
      api_name: window.location.hash
    });
  },

  CALCULATE_FNB_OFFER_VOUCHER_PRICE: (state, offer) => {
    if (offer.voucher_redeem_on_gross === "Y") {
      if (offer.voucher_is_percentage == "Y") {
        state.offerPrice =
          (parseFloat(
            store.getters.selectedFnBItemsTotalPrice +
            store.getters.TotalAdditionalTaxes
          ) *
            parseInt(offer.voucher_amount)) /
          100;
      } else if (offer.voucher_is_percentage == "N") {
        state.offerPrice = parseFloat(offer.voucher_amount);
      }
    } else if (offer.voucher_redeem_on_net === "Y") {
      if (offer.voucher_is_percentage == "Y") {
        state.offerPrice =
          (parseFloat(store.getters.selectedFnBItemsTotalPrice) *
            parseInt(offer.voucher_amount)) /
          100;
      } else if (offer.voucher_is_percentage == "N") {
        state.offerPrice = parseFloat(offer.voucher_amount);
      }
    }
    store.dispatch("onSetAndSendLog", {
      action: `Selected FNB offer value : ${state.offerPrice} `,
      page_name: "pos booking",
      api_name: window.location.hash
    });
  },

  CALCULATE_BOXOFFICE_FNB_OFFER_VOUCHER_PRICE: (state, offer) => {
    if (offer.voucher_redeem_on_gross === "Y") {
      if (offer.voucher_is_percentage == "Y") {
        state.offerPrice =
          (parseFloat(
            store.getters.selectedFnBItemsTotalPrice +
            store.getters.TotalAdditionalTaxes +
            store.getters.TOTAL_AMOUNT
          ) *
            parseInt(offer.voucher_amount)) /
          100;
      } else if (offer.voucher_is_percentage == "N") {
        state.offerPrice = parseFloat(offer.voucher_amount);
      }
    } else if (offer.voucher_redeem_on_net === "Y") {
      if (offer.voucher_is_percentage == "Y") {
        state.offerPrice =
          (parseFloat(
            store.getters.selectedFnBItemsTotalPrice + store.getters.NET_AMOUNT
          ) *
            parseInt(offer.voucher_amount)) /
          100;
      } else if (offer.voucher_is_percentage == "N") {
        state.offerPrice = parseFloat(offer.voucher_amount);
      }
    }
    store.dispatch("onSetAndSendLog", {
      action: `Selected BOX FNB offer price value : ${state.offerPrice} `,
      page_name: "pos booking",
      api_name: window.location.hash
    });
  },

  CALCULATE_FNB_OFFER_PRICE: (state, payload) => {
    if (payload.offer_applicable_on_gross_amount == "Y") {
      if (payload.offer_type_id == 6) {
        if (payload.pcs_offer_value) {
          if (payload.pcs_offer_value_is_percentage == "N") {
            state.offerPrice = parseFloat(payload.pcs_offer_value);
          } else if (payload.pcs_offer_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(
                store.getters.selectedFnBItemsTotalPrice +
                store.getters.TotalAdditionalTaxes
              ) *
                parseInt(payload.pcs_offer_value)) /
              100;
          }
        }
      } else if (payload.offer_type_id == 2) {
        if (payload.oc_discount_value) {
          if (payload.oc_discount_value_is_percentage == "N") {
            state.offerPrice =
              // store.getters.selectedFnBItemsTotalPrice +
              // store.getters.TotalAdditionalTaxes -
              payload.oc_discount_value;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            state.offerPrice =
              ((store.getters.selectedFnBItemsTotalPrice +
                store.getters.TotalAdditionalTaxes) *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        }
      } else {
        let offerFnbItem = store.getters.fnbItems.filter(fnbItem => {
          return fnbItem.item_id == payload.oc_get_item_id;
        });
        if (payload.oc_discount_value) {
          if (payload.oc_discount_value_is_percentage == "N") {
            // state.offerPrice = parseFloat(payload.oc_discount_value);
            state.offerPrice =
              offerFnbItem[0].fp_total_amount * payload.oc_get_item_count -
              payload.oc_discount_value;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            // state.offerPrice = (parseFloat(store.getters.selectedFnBItemsTotalPrice + store.getters.TotalAdditionalTaxes) * parseInt(payload.oc_discount_value)) / 100;
            state.offerPrice =
              (parseFloat(
                offerFnbItem[0].fp_total_amount * payload.oc_get_item_count
              ) *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        } else {
          //TODO - check quantity
          state.offerPrice =
            offerFnbItem && offerFnbItem.length > 0
              ? parseFloat(offerFnbItem[0].fp_total_amount) *
              payload.oc_get_item_count
              : 0;
        }
      }
    }
    //For Net Amount
    else if (payload.offer_applicable_on_net_amount == "Y") {
      if (payload.offer_type_id == 6) {
        if (payload.pcs_offer_value) {
          if (payload.pcs_offer_value_is_percentage == "N") {
            state.offerPrice = parseFloat(payload.pcs_offer_value);
          } else if (payload.pcs_offer_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(store.getters.selectedFnBItemsTotalPrice) *
                parseInt(payload.pcs_offer_value)) /
              100;
          }
        }
      } else if (payload.offer_type_id == 2) {
        if (payload.oc_discount_value) {
          if (payload.oc_discount_value_is_percentage == "N") {
            state.offerPrice =
              store.getters.selectedFnBItemsTotalPrice -
              payload.oc_discount_value;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            state.offerPrice =
              (store.getters.selectedFnBItemsTotalPrice *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        }
      } else {
        let offerFnbItem = store.getters.fnbItems.filter(fnbItem => {
          return fnbItem.item_id == payload.oc_get_item_id;
        });
        if (payload.oc_discount_value) {
          if (payload.oc_discount_value_is_percentage == "N") {
            // state.offerPrice = parseFloat(payload.oc_discount_value);
            state.offerPrice =
              offerFnbItem[0].fp_amount - payload.oc_discount_value;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            // state.offerPrice = (parseFloat(store.getters.selectedFnBItemsTotalPrice) * parseInt(payload.oc_discount_value)) / 100;
            state.offerPrice =
              (parseFloat(offerFnbItem[0].fp_amount) *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        }
      }
    }

    if (
      payload.oc_max_discount_amount &&
      state.offerPrice > payload.oc_max_discount_amount
    ) {
      state.offerPrice = payload.oc_max_discount_amount;
    }

    console.log(
      state.offerPrice,
      store.getters.selectedFnBItemsTotalPrice +
      store.getters.TotalAdditionalTaxes,
      state.offerPrice <
      store.getters.selectedFnBItemsTotalPrice +
      store.getters.TotalAdditionalTaxes
    );

    if (
      parseInt(state.offerPrice) >
      parseInt(
        store.getters.selectedFnBItemsTotalPrice +
        store.getters.TotalAdditionalTaxes
      )
    ) {
      state.offerPrice = 0;
      state.selectedOffers = {};
      state.promocode = "";
      Vue.toasted.show("Offer Not Applicable");
    }

    store.dispatch("onSetAndSendLog", {
      action: `Selected FNB offer value : ${state.offerPrice} `,
      page_name: "pos booking",
      api_name: window.location.hash
    });
  },
  CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE: (state, payload) => {
    if (payload.offer_applicable_on_gross_amount == "Y") {
      if (payload.offer_type_id == 6) {
        if (payload.pcs_offer_value) {
          if (payload.pcs_offer_value_is_percentage == "N") {
            state.offerPrice = parseFloat(payload.pcs_offer_value);
          } else if (payload.pcs_offer_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(
                store.getters.selectedFnBItemsTotalPrice +
                store.getters.TotalAdditionalTaxes +
                store.getters.TOTAL_AMOUNT
              ) *
                parseInt(payload.pcs_offer_value)) /
              100;
          }
        }
      } else {
        let offerFnbItem = store.getters.fnbItems.filter(fnbItem => {
          return (fnbItem.item_id == payload.oc_get_item_id || fnbItem.item_code == payload.oc_get_item_code);
        });
        if (
          payload.oc_buy_no_of_ticket &&
          payload.oc_get_item_id &&
          payload.oc_discount_value
        ) {
          if (payload.oc_discount_value_is_percentage == "N") {
            state.offerPrice = payload.oc_discount_value;
            // offerFnbItem[0].fp_total_amount -
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(offerFnbItem[0].fp_total_amount) *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        } else if (payload.oc_buy_no_of_ticket && payload.oc_get_item_id) {
          if (offerFnbItem.length > 0) {
            state.offerPrice = offerFnbItem[0].fp_total_amount;
          }
        } else if (payload.oc_discount_value && payload.offer_type_id !== 2) {
          if (payload.oc_discount_value_is_percentage == "N") {
            state.offerPrice =
              (parseFloat(
                offerFnbItem[0].fp_total_amount * payload.oc_get_item_count
              ) *
                parseInt(payload.oc_discount_value)) /
              100;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(
                offerFnbItem[0].fp_total_amount * payload.oc_get_item_count
              ) *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        } else if (payload.offer_type_id === 2) {
          if (payload.oc_discount_value_is_percentage == "N") {
            let totalNumberOfApplicableTickets = Math.floor(
              store.getters.SelectedFnbItemList.length /
              payload.oc_buy_no_of_ticket
            );
            state.offerPrice =
              parseFloat(payload.oc_discount_value) *
              totalNumberOfApplicableTickets;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            let totalNumberOfApplicableTickets = Math.floor(
              store.getters.SelectedFnbItemList.length /
              payload.oc_buy_no_of_ticket
            );
            state.offerPrice =
              ((parseFloat(store.getters.TOTAL_AMOUNT) *
                parseInt(payload.oc_discount_value)) /
                100) *
              totalNumberOfApplicableTickets;
          }
          if (
            payload.oc_max_discount_amount &&
            payload.oc_discount_value_is_percentage == "Y"
          ) {
            let totalNumberOfApplicableTickets = Math.floor(
              store.getters.SelectedFnbItemList.length /
              payload.oc_buy_no_of_ticket
            );
            let maxDiscountPercentage =
              totalNumberOfApplicableTickets * payload.oc_discount_value;
            console.log("maxDiscountPercentage :>> ", maxDiscountPercentage);
            if (maxDiscountPercentage > payload.oc_max_discount_amount) {
              if (payload.offer_applicable_on_net_amount == "Y") {
                state.offerPrice =
                  (parseFloat(store.getters.NET_AMOUNT) *
                    parseInt(payload.oc_max_discount_amount)) /
                  100;
              } else if (payload.offer_applicable_on_gross_amount == "Y") {
                state.offerPrice =
                  (parseFloat(store.getters.TOTAL_AMOUNT) *
                    parseInt(payload.oc_max_discount_amount)) /
                  100;
              }
            }
          } else if (
            payload.oc_max_discount_amount &&
            state.offerPrice > payload.oc_max_discount_amount &&
            payload.oc_discount_value_is_percentage == "N"
          ) {
            state.offerPrice = payload.oc_max_discount_amount;
          }
        } else {
          state.offerPrice =
            offerFnbItem[0].fp_total_amount * payload.oc_get_item_count;
        }
      }
    }
    //For Net Amount
    else if (payload.offer_applicable_on_net_amount == "Y") {
      if (payload.offer_type_id == 6) {
        if (payload.pcs_offer_value) {
          if (payload.pcs_offer_value_is_percentage == "N") {
            state.offerPrice = parseFloat(payload.pcs_offer_value);
          } else if (payload.pcs_offer_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(
                store.getters.selectedFnBItemsTotalPrice +
                store.getters.NET_AMOUNT
              ) *
                parseInt(payload.pcs_offer_value)) /
              100;
          }
        }
      } else {
        let offerFnbItem = store.getters.fnbItems.filter(fnbItem => {
          return (fnbItem.item_id == payload.oc_get_item_id || fnbItem.item_code == payload.oc_get_item_code);
        });
        if (
          payload.oc_buy_no_of_ticket &&
          payload.oc_get_item_id &&
          payload.oc_discount_value
        ) {
          if (payload.oc_discount_value_is_percentage == "N") {
            state.offerPrice =
              offerFnbItem[0].fp_amount - payload.oc_discount_value;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(offerFnbItem[0].fp_amount) *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        } else if (payload.oc_buy_no_of_ticket && payload.oc_get_item_id) {
          if (offerFnbItem.length > 0) {
            state.offerPrice = offerFnbItem[0].fp_total_amount;
          }
        } else if (payload.oc_discount_value) {
          if (payload.oc_discount_value_is_percentage == "N") {
            state.offerPrice = parseFloat(payload.oc_discount_value);
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            state.offerPrice =
              (parseFloat(store.getters.selectedFnBItemsTotalPrice) *
                parseInt(payload.oc_discount_value)) /
              100;
          }
        } else if (payload.offer_type_id === 2) {
          if (payload.oc_discount_value_is_percentage == "N") {
            let totalNumberOfApplicableTickets = Math.floor(
              store.getters.fnbItems.length / payload.oc_buy_no_of_ticket
            );
            state.offerPrice =
              parseFloat(payload.oc_discount_value) *
              totalNumberOfApplicableTickets;
          } else if (payload.oc_discount_value_is_percentage == "Y") {
            let totalNumberOfApplicableTickets = Math.floor(
              store.getters.fnbItems.length / payload.oc_buy_no_of_ticket
            );
            state.offerPrice =
              ((parseFloat(store.getters.TOTAL_AMOUNT) *
                parseInt(payload.oc_discount_value)) /
                100) *
              totalNumberOfApplicableTickets;
          }
          if (
            payload.oc_max_discount_amount &&
            payload.oc_discount_value_is_percentage == "Y"
          ) {
            let totalNumberOfApplicableTickets = Math.floor(
              store.getters.fnbItems.length / payload.oc_buy_no_of_ticket
            );
            let maxDiscountPercentage =
              totalNumberOfApplicableTickets * payload.oc_discount_value;
            console.log(
              "maxDiscountPercentage final :>> ",
              maxDiscountPercentage
            );
            if (maxDiscountPercentage > payload.oc_max_discount_amount) {
              if (payload.offer_applicable_on_net_amount == "Y") {
                state.offerPrice =
                  (parseFloat(store.getters.NET_AMOUNT) *
                    parseInt(payload.oc_max_discount_amount)) /
                  100;
              } else if (payload.offer_applicable_on_gross_amount == "Y") {
                state.offerPrice =
                  (parseFloat(store.getters.TOTAL_AMOUNT) *
                    parseInt(payload.oc_max_discount_amount)) /
                  100;
              }
            }
          }
        } else {
          state.offerPrice =
            offerFnbItem[0].fp_amount * payload.oc_get_item_count;
        }
      }
    }
    store.dispatch("onSetAndSendLog", {
      action: `Selected BOX OFFICE FNB offer value : ${state.offerPrice} `,
      page_name: "pos booking",
      api_name: window.location.hash
    });
  },
  SET_OFFER_ITEM_REMOVE_FLAG: (state, payload) => {
    state.offersPosFlags.isOfferItemRemoved = payload;
  },
  SET_OFFER_FOR_FNB_PICKUP: (state, payload) => {
    if (
      payload.MainDetails[0].offer_title != null ||
      payload.MainDetails[0].voucher_title != null
    ) {
      state.selectedOffers = payload.MainDetails[0];
      state.offerPrice = payload.MainDetails[0];
    }
  },
  SET_CLEAR_CARD_NUMBER: (state, payload) => {
    state.CardNumber = payload;
  },
  RESET_OFFER_PRICE_DETAILS: (state, payload) => {
    state.isOfferAppliedV2 = false;
    if (state.offerPrice && state.offerPrice > 0) {
      // await dispatch("addOfferVoucherLogs", {
      //   offer_id: state.selectedOffers.os_id,
      //   voucher_id: state.selectedOffers.voucher_id || null,
      //   t_offer_price: state.offerPrice,
      //   cinema_id: authenticationService.get("USINFO").cinema_id || null,
      //   booking_source_id: 1 || null, //make this dynamic
      //   action: "Removed",
      //   amount: store.getters.TOTAL_AMOUNT
      // });
      state.isOfferAppliedV2 = false;
    }
  }
};

const actions = {
  CLEAR_CARD_NUMBER: ({ dispatch, commit, state }, payload) => {
    commit("SET_CLEAR_CARD_NUMBER", payload);
  },
  OFFER_DETAILS_FOR_FNB_PICKUP: ({ dispatch, commit, state }, payload) => {
    commit("SET_OFFER_FOR_FNB_PICKUP", payload);
  },
  CHANGE_FLAG_ShowViewOffers: ({ dispatch, commit, state }, payload) => {
    commit("SET_FLAG_ShowViewOffers", payload);
  },
  onResetOffersStoreState: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("ON_RESET_OFFERS_STORE_STATE");
  },
  onResetOffersAndPrice: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    // state.isOfferAppliedV2 = false;
    // if (state.offerPrice && state.offerPrice > 0) {
    //   // await dispatch("addOfferVoucherLogs", {
    //   //   offer_id: state.selectedOffers.os_id,
    //   //   voucher_id: state.selectedOffers.voucher_id || null,
    //   //   t_offer_price: state.offerPrice,
    //   //   cinema_id: authenticationService.get("USINFO").cinema_id || null,
    //   //   booking_source_id: 1 || null, //make this dynamic
    //   //   action: "Removed",
    //   //   amount: store.getters.TOTAL_AMOUNT
    //   // });
    //   state.isOfferAppliedV2 = false;
    // }
    // await commit('SET_POS_OFFERS_FLAGS', { name: "isPosOffersShow", value: false });
    vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
    vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
    await commit("RESET_OFFER_PRICE_DETAILS");
    await commit("ON_RESET_SELECTET_OFFER_AND_PRICE");
    let pm_object = {
      pm_id: 1,
      pm_payment_mode: "Cash"
    };
    // store.dispatch("setPaymentMode", pm_object);
    store.dispatch("onResetEmployeeDetails");
  },
  onSetOffersFlags: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_POS_OFFERS_FLAGS", payload);
    if (!payload.value) await commit("SET_OFFERS_EMPTY", []);
  },
  onSetSelectedOfferId: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_OFFERS_STATES", payload);
  },
  onSelectVoucher: async ({ dispatch, commit, state }, { ...payload }) => {
    commit("SET_TEMP_OFFER_DATA", payload);
  },
  fetchOffersList: async ({ dispatch, commit, state }, payload) => {
    // await ommit('SET_OFFERS_STATES', { seat_type_id: payload.seat_type_id });
    // await dispatch("fetchCustomerCategoriesList");
    await commit("SET_POS_OFFERS_FLAGS", {
      name: "isPosOffersShow",
      value: true
    });
    await commit("SET_OFFERS_LIST", []);
    // let loader = Vue.$loading.show();

    // console.log('state.offersObject :', state.offersObject);

    let cinema_id = authenticationService.get("USINFO").cinema_id || null;

    // state.offersObject['cinema_id'] = cinema_id;
    await commit("SET_OFFERS_STATES", { name: "isCinema", id: cinema_id });

    MarketingService.GetOffersCollections(state.offersObject)
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            await commit(
              "SET_CINEMA_SETTING",
              data["CinemaSettings"] && data["CinemaSettings"].length > 0
                ? data["CinemaSettings"][0]
                : {}
            );
            await commit("SET_OFFERS_LIST", data["Records"] || []);
            // await commit('SET_POS_OFFERS_FLAGS', { name: "isPosOffersShow", value: true });
          }
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on fetchOffersList", error);
      })
      .finally(() => {
        // setTimeout(() => loader.hide(), 1000);
      });
  },
  fetchFnbOffersList: async ({ dispatch, commit, state }, payload) => {
    // await ommit('SET_OFFERS_STATES', { seat_type_id: payload.seat_type_id });
    await dispatch("fetchCustomerCategoriesList");
    await commit("SET_POS_OFFERS_FLAGS", {
      name: "isPosOffersShow",
      value: true
    });
    await commit("SET_OFFERS_LIST", []);
    // let loader = Vue.$loading.show();

    // console.log('state.offersObject :', state.offersObject);

    MarketingService.GetFnbOffersCollections(state.offersObject)
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            await commit(
              "SET_CINEMA_SETTING",
              data["CinemaSettings"] && data["CinemaSettings"].length > 0
                ? data["CinemaSettings"][0]
                : {}
            );
            await commit("SET_OFFERS_LIST", data["Records"] || []);
            // await commit('SET_POS_OFFERS_FLAGS', { name: "isPosOffersShow", value: true });
          }
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on fetchOffersList", error);
      })
      .finally(() => {
        // setTimeout(() => loader.hide(), 1000);
      });
  },
  fetchOffersVouchersList: async ({ dispatch, commit, state }, payload) => {
    if(store.getters.CLIENT_SETUP_NAME.toLowerCase() != CLIENT_NAME.EMPIRE.toLowerCase()) {
    MarketingService.GetOffersVoucherCollections(state.offersObject)
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            await commit(
              "SET_CINEMA_SETTING",
              data["CinemaSettings"] && data["CinemaSettings"].length > 0
                ? data["CinemaSettings"][0]
                : {}
            );
            await commit("SET_OFFERS_VOUCHERS_LIST", data["Records"] || []);
            // await commit('SET_POS_OFFERS_FLAGS', { name: "isPosOffersShow", value: true });
          }
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on fetchOffersVouchersList", error);
      })
      .finally(() => {
        // setTimeout(() => loader.hide(), 1000);
      });
    }
  },

  fetchFnbVouchersList: async ({ dispatch, commit, state }, payload) => {
    if(store.getters.CLIENT_SETUP_NAME.toLowerCase() != CLIENT_NAME.EMPIRE.toLowerCase()) {
    MarketingService.GetFnbOffersVoucherCollections(state.offersObject)
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            await commit(
              "SET_CINEMA_SETTING",
              data["CinemaSettings"] && data["CinemaSettings"].length > 0
                ? data["CinemaSettings"][0]
                : {}
            );
            await commit("SET_OFFERS_VOUCHERS_LIST", data["Records"] || []);
            // await commit('SET_POS_OFFERS_FLAGS', { name: "isPosOffersShow", value: true });
          }
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on fetchOffersVouchersList", error);
      })
      .finally(() => {
        // setTimeout(() => loader.hide(), 1000);
      });
    }
  },

  fetchVerificationList: async ({ dispatch, commit, state }, payload) => {
    MarketingService.GetVerificationList()
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0)
            commit("SET_OFFERS_VERIFICATION_LIST", data.Records);
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error =>
        Vue.toasted.show("Catch Error on fetchVerificationList", error)
      )
      .finally(() => {
        // setTimeout(() => loader.hide(), 1000);
      });
  },
  fetchCustomerCategoriesList: async ({ dispatch, commit, state }, payload) => {
    MarketingService.GetCustomerCategories()
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          if (data.Records.length > 0) {
            commit("SET_OFFERS_CATEGORIES_LIST", data.Records);
          }
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on fetchCustomerCategoriesList", error);
      })
      .finally(() => {
        // setTimeout(() => loader.hide(), 1000);
      });
  },
  getOfferVerificationName: async ({ dispatch, commit, state }, payload) => {
    // state.offerVerificationList.filter((x)=> x.)
  },
  getOfferCategoriesName: async ({ dispatch, commit, state }, payload) => {
    let list = payload && payload.length > 0 ? payload.split(", ") : [];
    let StrName = "";
    let promiselist = list.map(x => {
      let a = state.offerCategoriesList.filter(
        y => String(x) === String(y.buc_id)
      );
      if (a.length > 0) {
        StrName +=
          StrName.length > 0
            ? `, ${a[0].buc_category_name}`
            : `${a[0].buc_category_name}`;
      }
    });
    await Promise.all(promiselist);
    return StrName;
  },
  onEnterPromoCodes: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_ENTER_PROMO_CODE", payload);
  },
  onEnterVoucherCode: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_ENTER_VOUCHER_CODE", payload);
  },
  onEnterVoucherAmount: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_VOUCHER_AMOUNT", payload);
  },
  onEnterVoucherComment: async ({ dispatch, commit, state }, payload) => {
    let comment = payload.target.value;
    await commit("SET_VOUCHER_COMMENT", comment);
  },
  ResetVoucherCode: async ({ dispatch, commit, state }, payload) => {
    await commit("RESET_VOUCHER_CODE");
    await commit("RESET_COMMENT");
  },
  applyOpenVoucher: async ({ dispatch, commit, state }, payload) => {
    //here-
    let { amount, voucher } = payload;
    console.log(
      "state.openVoucher.totalGrossAmount",
      state.openVoucher.totalGrossAmount
    );
    console.log("amount", amount);
    if (amount < 1) {
      return Vue.toasted.show("Please Enter a Valid Amount.");
    } else if ((state.openVoucher.totalGrossAmount >= amount && voucher.offer.is_allow_cash_refund == 'N') || voucher.offer.is_allow_cash_refund == 'Y') {
      let remaingOfferPrice = 0;
      await commit("SET_REMAINING_PRICE", 0)
      if (voucher.offer.is_allow_cash_refund == 'Y') {
        if (state.openVoucher.totalGrossAmount >= amount) {
          amount = amount
        } else {
          remaingOfferPrice = parseFloat(amount - state.openVoucher.totalGrossAmount).toFixed(2);
          amount = state.openVoucher.totalGrossAmount;
          vmVue.$root.$emit("bv::show::modal", "refund_cash_popup");
        }
      }
      console.log("remaingOfferPrice", remaingOfferPrice)
      let payload = {
        TotalOfferPrice: amount
      };


      commit("SET_OFFER_VOUCHER_PRICE", payload);
      commit("SET_REMAINING_PRICE", remaingOfferPrice);
      await commit("SET_SELECTED_OFFERS", voucher);
      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
      vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
      vmVue.$root.$emit("bv::hide::modal", "verifyVoucherFnb");
      vmVue.$root.$emit("bv::hide::modal", "tt_modal_open_voucher");
      vmVue.$root.$emit("bv::hide::modal", "total_discount_popup");
      vmVue.$root.$emit("bv::hide::modal", "total_discount_popup_tt");
    } else {
      Vue.toasted.show(
        "Voucher Discount cannot be more than total gross price"
      );
    }
  },
  changeCountHandlerOpenVoucher: async (
    { dispatch, commit, state },
    payload
  ) => {
    const { item, index, type } = payload;
    if (item.is_complemetory_ticket == "Y") {
      if (type == "increment") {
        console.log("item", item);
        commit("INCREASE_TICKET_TYPE_COUNT", index);
      } else if (type == "decrement") {
        if (state.openVoucherSeatTypeArray[index].selected == 0) {
          Vue.toasted.show("Selected Count Cannot be less than zero");
        } else {
          commit("DECREASE_TICKET_TYPE_COUNT", index);
        }
      }
    }
  },
  addComplimetoryVoucher: async ({ dispatch, commit, state }, payload) => {
    const { item, index, type } = payload;
  },
  onClickVoucherBox: async ({ dispatch, commit, state }, { ...payload, isFnbVoucher = false }) => {
    let Voucher = payload;
    if (
      state.isOfferAppliedV2 &&
      Object.keys(state.selectedOffers).length > 0
    ) {
      if (state.selectedOffers.voucher_code == Voucher.voucher_code) {
        await store.dispatch("changeCountHandlerOpenVoucher", {
          item: Voucher,
          index: 0,
          type: "increment"
        });
      } else {
        Vue.toasted.show(
          "Voucher is Already Applied!, Please Remove the selected Voucher to apply."
        );
      }
    } else {
      if (Voucher.is_code_required == "N") {
        let voucherCode = {
          target: {
            value: Voucher.voucher_code
          }
        };
        await dispatch("onEnterVoucherCode", {
          event: voucherCode,
          name: "enterVoucherCode"
        });

        if(store.getters.SELECTED_SEATS.length>0 && isFnbVoucher){
          await dispatch("applyBoxOfficeFnbOffersHandler", {
            event: null,
            offer: Voucher,
            offerFor: "BoxOfficeFnbVouchers"
          });

        }else if (isFnbVoucher) {
          await dispatch("applyFnbOffersHandler", {
            event: null,
            offer: Voucher,
            offerFor: "fnbVouchers"
          });

        } else {
          await dispatch("applyOffersHandler", {
            event: null,
            offer: Voucher,
            offerFor: "vouchers",
            booking_source_id: 1
          });
        }

      } else {
        if (isFnbVoucher) {
        vmVue.$root.$emit("bv::show::modal", "verifyVoucherFnb");
        }else{
          vmVue.$root.$emit("bv::show::modal", "verifyVoucher");
        }
      }
    }
  },
  applyOffersHandler: async ({ dispatch, commit, state }, payload) => {
    const { event, offerFor, booking_source_id } = payload;
    let checkSpecificTitle = payload.hasOwnProperty('checkSpecificTitle') ? payload.checkSpecificTitle : 'N'
    let offer = payload.offer;
    let cinema_id = authenticationService.get("USINFO").cinema_id;
    await store.dispatch("resetLoyaltyData");
    commit('RESET_REMAINING_PRICE');
    if (offerFor === "offersAndPromotions") {
      console.log("Offer", offer);
      let loader = Vue.$loading.show();
      let objPayload = {
        oc_id: offer.oc_id,
        total_amount: parseFloat(store.getters.TOTAL_AMOUNT) - parseFloat(store.getters.RateCardAddonsChargesFinalAmount|| 0),
        net_amount: store.getters.NET_AMOUNT,
        cinema_id: cinema_id,
        md_id: store.getters.getMovieDetailsId,
        isTicket: true,
        cinema_name: authenticationService.get("USINFO").cine_name,
        total_ticket: store.getters.SELECTED_SEATS.length,
        ss_start_show_time: store.getters.SHOW_DETAILS.ss_start_show_time,
        customer_id: store.getters.cust_id,
        reservation_id: store.getters.reservationId,
        fnb_items: store.getters.SelectedFnbItemList || []
      };
      MarketingService.AddOfferVoucherLogsV2(objPayload)
        .then(async response => {
          const { data } = response;
          if (data && data.status) {
            console.log('CALLING THIS FUNCTION APPPLY OFFER STORE', store);
            offer = data.Records[0];
            if(offer && offer.offer_type_id == 3) {
              if (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "Y" && offer.oc_is_combo_with_fnb == "N") {
                let TotalSeats = store.getters.SELECTED_SEATS.length || 0;
                if (
                  store.getters.SELECTED_SEATS.length >= offer.oc_buy_no_of_ticket
                ) {
                  console.log("Offer12", store.getters.fnbItems);
                  console.log('offer.oc_get_item_id', offer.oc_get_item_code, offer.item_code);
      
                  let offerFnbItem = store.getters.fnbItems.filter((x) => ((offer.oc_get_item_code && (x.item_code == offer.oc_get_item_code)) || offer.item_id == x.item_id) && checkItemAvailable(x))
                  console.log("offerFnbItem", offerFnbItem);
      
                  let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex((x) => (offer.oc_get_item_code && (x.item_code == offer.oc_get_item_code)) || offer.oc_get_item_id == x.item_id)
                  let getItemCount = 0
                  store.getters.SelectedFnbItemList.forEach((x) => {
                    if(x.item_id == offer.oc_get_item_id || x.item_code == offer.oc_get_item_code) {
                      getItemCount+= x.quantity;
                    }
                  })
                  let totalFreeItemQty = 0;
                  if (
                    offer.oc_buy_no_of_ticket == offer.oc_get_item_count
                    && offer.oc_buy_no_of_ticket > 1
                  ) {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        TotalSeats /
                          parseInt(
                            offer.oc_buy_no_of_ticket +
                              offer.oc_get_item_count
                          )
                      ) * offer.oc_get_item_count
                    );
                  } else {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        TotalSeats / parseInt(offer.oc_buy_no_of_ticket)
                      ) * offer.oc_get_item_count
                    );
                  }

                  if (offerFnbItem.length > 0) {
                    offerFnbItem[0]["quantity"] = totalFreeItemQty ? totalFreeItemQty : 1;
                    offerFnbItem[0]["add_custom_quantity"] = 'Y';
                    await store.dispatch("onAddFnBList", offerFnbItem[0]);

                    let fnbObj = {
                      ...offerFnbItem[0],
                      quantity: totalFreeItemQty || 1,
                      item_is_compulsory: "Y",
                      is_package_ticket: "Y"
                    };
                    let additionalPayload = {
                      ...payload,
                      item_id: offerFnbItem[0].item_id
                    }
                    await store.dispatch("addFnbItemFromBoxOffice", fnbObj);
                    await store.dispatch("fetchFnBAdditionalPrice", additionalPayload);

                    await commit("SET_SELECTED_OFFERS", payload);
                    await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                    // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                    vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                    vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                  } else {
                    await dispatch("onResetOffersAndPrice");
                    Vue.toasted.show(
                      "FNB item Not Found"
                    );
                  }
                } else {
                  await dispatch("onResetOffersAndPrice");
                  Vue.toasted.show(
                    "Please select atleast " +
                    offer.oc_buy_no_of_ticket +
                    " ticket(s)"
                  );
                }
              
              } else if (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "N" && offer.oc_is_combo_with_fnb == "N") {

                let TotalSeats = store.getters.SELECTED_SEATS.length || 0;
                if (
                  store.getters.SELECTED_SEATS.length >= offer.oc_buy_no_of_ticket
                ) {
                  console.log("Offer12", store.getters.fnbItems);
                  console.log('offer.oc_get_item_id', offer.oc_get_item_code, offer.item_code);
      
                  let offerFnbItem = store.getters.fnbItems.filter((x) => ((offer.oc_get_item_code && (x.item_code == offer.oc_get_item_code)) || offer.oc_get_item_id == x.item_id) && checkItemAvailable(x))
      
                  console.log("offerFnbItem", offerFnbItem);
      
                  let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex((x) => (offer.oc_get_item_code && (x.item_code == offer.oc_get_item_code)) || offer.oc_get_item_id == x.item_id)
                  let getItemCount = 0
                  store.getters.SelectedFnbItemList.forEach((x) => {
                    if(x.item_id == offer.oc_get_item_id || x.item_code == offer.oc_get_item_code) {
                      getItemCount+= x.quantity;
                    }
                  })
                  let totalFreeItemQty = 0;
                  if (
                    offer.oc_buy_no_of_ticket == offer.oc_get_item_count
                    && offer.oc_buy_no_of_ticket > 1
                  ) {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        TotalSeats /
                          parseInt(
                            offer.oc_buy_no_of_ticket +
                              offer.oc_get_item_count
                          )
                      ) * offer.oc_get_item_count
                    );
                  } else {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        TotalSeats / parseInt(offer.oc_buy_no_of_ticket)
                      ) * offer.oc_get_item_count
                    );
                  }

                  if (offerFnbItem.length > 0) {
                    offerFnbItem[0]["quantity"] = totalFreeItemQty ? totalFreeItemQty : 1;
                    offerFnbItem[0]["add_custom_quantity"] = 'Y';
                    await store.dispatch("onAddFnBList", offerFnbItem[0]);
                    
                    let fnbObj = {
                      ...offerFnbItem[0],
                      quantity: totalFreeItemQty || 1,
                      item_is_compulsory: "Y",
                      is_package_ticket: "Y"
                    };

                    let additionalPayload = {
                      ...payload,
                      item_id: offerFnbItem[0].item_id
                    }
                    await store.dispatch("addFnbItemFromBoxOffice", fnbObj);
                    await store.dispatch("fetchFnBAdditionalPrice", additionalPayload);

                    await commit("SET_SELECTED_OFFERS", payload);
                    await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                    // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                    vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                    vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                  } else {
                    await dispatch("onResetOffersAndPrice");
                    Vue.toasted.show(
                      "FNB item Not Found"
                    );
                  }
                } else {
                  await dispatch("onResetOffersAndPrice");
                  Vue.toasted.show(
                    "Please select atleast " +
                    offer.oc_buy_no_of_ticket +
                    " ticket(s)"
                  );
                }
            
              }
            } else if(offer && offer.offer_type_id == 9) {
              let TotalSeats = store.getters.SELECTED_SEATS.length || 0;
              let totalTicketOffer = 0;
              totalTicketOffer = parseInt(
                Math.floor(
                  TotalSeats / parseInt(offer.oc_buy_no_of_ticket)
                )
              );

              if (
                offer.oc_max_no_of_ticket_per_transaction &&
                totalTicketOffer > offer.oc_max_no_of_ticket_per_transaction &&
                offer.oc_max_no_of_ticket_per_transaction > 0
              ) {
                totalTicketOffer = offer.oc_max_no_of_ticket_per_transaction;
              }

              if (store.getters.SELECTED_SEATS.length >= offer.oc_buy_no_of_ticket) {
                if(offer.oc_is_combo_with_fnb == "Y") {
                  let fnbItemsArray = offer.fnb_group_data || [];
                  let errorCount = 0;
                  for(let i=0; i<fnbItemsArray.length; i++) {
                  let itemObj = fnbItemsArray[i];
                    console.log('itemObj', itemObj);
                    let offerFnbItem = store.getters.fnbItems.filter((x) => (((x.item_code == itemObj.oc_buy_item_code)) || itemObj.oc_buy_item_id == x.item_id) && checkItemAvailable(x))
                    if (offerFnbItem.length > 0) {

                      offerFnbItem[0]["quantity"] = parseInt(itemObj.oc_buy_no_of_item || 1) * parseInt(totalTicketOffer || 1);

                      offerFnbItem[0]["add_custom_quantity"] = 'Y';

                      await store.dispatch("onAddFnBList", offerFnbItem[0]);
                      
                      let fnbObj = {
                        ...offerFnbItem[0],
                        quantity: parseInt(itemObj.oc_buy_no_of_item || 1) * parseInt(totalTicketOffer || 1),
                        item_is_compulsory: "Y",
                        is_package_ticket: "Y"
                      };
  
                      let additionalPayload = {
                        ...payload,
                        item_id: offerFnbItem[0].item_id
                      }

                      await store.dispatch("addFnbItemFromBoxOffice", fnbObj);
                      await store.dispatch("fetchFnBAdditionalPrice", additionalPayload);
                      console.log('apply voucher ticket');
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                      // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                      vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                    } else {
                      errorCount++;
                    }
                  }
                  if(errorCount > 0) {
                    await dispatch("onResetOffersAndPrice");
                    await store.commit("REMOVE_SELECTED_FNB_ITEMS");
                    Vue.toasted.show(
                      "FNB item Not Found"
                    );
                  }
                } else {
                  await commit("SET_SELECTED_OFFERS", payload);
                  await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                  // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                  vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                  vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                }
              } else {
                await dispatch("onResetOffersAndPrice");
                  Vue.toasted.show(
                    "Please select atleast " +
                    offer.oc_buy_no_of_ticket +
                    " ticket(s)"
                  );
              }
            } else {
              await commit("SET_SELECTED_OFFERS", payload);
              await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
              vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
              vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
              Vue.toasted.show(data.message);
            }
          } else {
            Vue.toasted.show(data.message);
            await dispatch("onResetOffersAndPrice");
          }
        })
        .catch(error => {
          console.log('ERROR line 1638', error);
          Vue.toasted.show("Catch Error on fetchOffersVouchersList", error);
        }).finally(() => {
          loader.hide()
        })
    } else if (offerFor === "vouchers") {
      console.log(" state.voucherCode", state.voucherCode);
      console.log(" offer.voucher_code", offer.voucher_code);
      if (String(state.voucherCode).length == 0) {
        Vue.toasted.show("Please Enter voucher code");
      } else if (
        false &&
        state.voucherCode != offer.voucher_code &&
        offer.is_code_required == "Y" &&
        !payload.hasOwnProperty("is_voucher_with_offers")
      ) {
        Vue.toasted.show("Voucher Not Exist");
      } else {
        console.log(" state.voucherCode", state.voucherCode);
        console.log(" offer.voucher_code", offer.voucher_code);
        /* else if (String(state.voucherComment).length == 0) {
        Vue.toasted.show("Please Enter Comment");
      } */
        let loader = Vue.$loading.show();
        MarketingService.VerifyVoucherCodeV2({
          voucher_code:
            String(state.voucherCode).length > 0
              ? state.voucherCode
              : offer.hasMultiple == "N"
                ? offer.voucher_code
                : "",
          is_code_required: offer.is_code_required,
          voucher_title: "_" + offer.voucher_title,
          total_amount: parseFloat(store.getters.TOTAL_AMOUNT || 0) - parseFloat(store.getters.RateCardAddonsChargesFinalAmount || 0),
          net_amount: store.getters.NET_AMOUNT,
          cinema_id: cinema_id,
          md_id: store.getters.getMovieDetailsId,
          isTicket: true,
          cinema_name: authenticationService.get("USINFO").cine_name,
          total_ticket: store.getters.SELECTED_SEATS.length,
          reservation_id: store.getters.reservationId,
          customer_id: store.getters.cust_id,
          fnb_items: store.getters.SelectedFnbItemList || [],
          checkSpecificTitle: checkSpecificTitle,
        })
          .then(async response => {
            const { data } = response;
            if (data && data.status) {
              let Voucherobj = {
                offer: data.Records[0],
                offerFor: offerFor
              };
              offer = data.Records[0];
              commit("SET_TEMP_OFFER_DATA", offer);
              if (data.hasOwnProperty("isOpenVoucher") && data.isOpenVoucher) {
                await commit("SET_OPEN_VOUCHER_INFO", data);
                if (
                  data.hasOwnProperty("isComplementary") &&
                  data.isComplementary &&
                  data.ticketTypeId
                ) {
                  let checkValidation = true;
                  if (offer.hasOwnProperty("screen_id") && offer.screen_id) {
                    let Screen = store.getters.newSeatLayoutArrayState.filter(
                      x => x.screen_id == offer.screen_id
                    );
                    if (Screen.length == 0) {
                      checkValidation = false;
                    }
                  }
                  if (!checkValidation) {
                    Vue.toasted.show("Voucher not valid for selected screen!");
                    await dispatch("onResetOffersAndPrice");
                  } else {
                    // let totalTicketType = data.totalTicketType || 0;
                    // vmVue.$root.$emit("bv::show::modal", "tt_modal_open_voucher");
                    await store.dispatch("changeCountHandlerOpenVoucher", {
                      item: offer,
                      index: 0,
                      type: "increment"
                    });
                    Vue.toasted.show(
                      `${offer.voucher_title ? offer.voucher_title : ""
                      } Voucher Applied!`
                    );
                    await commit("SET_SELECTED_OFFERS", Voucherobj);
                    vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
                    vmVue.$root.$emit("bv::hide::modal", "verifyVoucherFnb");

                  }
                  //show a ticket type popup with plus minus of ticket type not greator than totalTicketType and than apply
                } else if (
                  data.hasOwnProperty("isComplementary") &&
                  !data.isComplementary &&
                  data.ticketTypeId
                ) {
                  Vue.toasted.show("Invalid Voucher!");
                  await dispatch("onResetOffersAndPrice");
                  // vmVue.$root.$emit(
                  //   "bv::show::modal",
                  //   "total_discount_popup_tt"
                  // );
                  // vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
                  //show a popup with a number field to enter amount not gretor then total amount of ticket type * ticket type count
                } else if (
                  data.hasOwnProperty("isComplementary") &&
                  !data.isComplementary &&
                  !data.ticketTypeId
                ) {
                  vmVue.$root.$emit("bv::show::modal", "total_discount_popup");
                  vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
                  vmVue.$root.$emit("bv::hide::modal", "verifyVoucherFnb");

                  //show a popup with a number field to enter amount not gretor then total amount of ticket type * ticket type count
                } else {
                  Vue.toasted.show("Something Went Wrong!");
                }
              } else {
                await commit("SET_SELECTED_OFFERS", Voucherobj);
                await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
                vmVue.$root.$emit("bv::hide::modal", "verifyVoucherFnb");
                Vue.toasted.show(data.message);
              }
            } else {
              await dispatch("onResetOffersAndPrice");
              Vue.toasted.show(data.message);
            }
          })
          .catch(async error => {
            await dispatch("onResetOffersAndPrice");
            await dispatch("ResetVoucherCode");
            Vue.toasted.show("Catch Error on Voucher", error.message);
          }).finally(() => {
            loader.hide()
          })
      }
    }
  },

  applyFnbOffersHandler: async ({ dispatch, commit, state }, payload) => {
    // if(store.getters.hasOwnProperty("customerID") && store.getters.customerID){
    await store.dispatch("validateCustomerPoints");
  
    console.log("OFFFFFFFF", payload);
    const { event } = payload;
    let checkSpecificTitle = payload.hasOwnProperty('checkSpecificTitle') ? payload.checkSpecificTitle : 'N'
    let offerFor=payload.offerFor;
    if(store.getters.SELECTED_SEATS.length>0 && offerFor=='fnbVouchers'){
      offerFor="BoxOfficeFnbVouchers"
    }
    let offer = payload.offer;
    await store.dispatch("resetLoyaltyData");
    commit('RESET_REMAINING_PRICE');
    if (offerFor === "fnbOffers") {
      if (offer.oc_id) {
        let SelectedFnbItems = store.getters.SelectedFnbItemList;
        let totalFnbCount = 0;
        SelectedFnbItems.map(x => {
          totalFnbCount += x.quantity;
        });
        let loader = Vue.$loading.show();
        console.log("Offer", offer);
        let objPayload = {
          oc_id: offer.oc_id,
          isTicket: false,
          total_ticket: store.getters.SelectedFnbItemList.length,
          net_amount: store.getters.selectedFnBItemsTotalPrice,
          total_amount:
            store.getters.selectedFnBItemsTotalPrice +
            store.getters.TotalAdditionalTaxes,
          cinema_name: authenticationService.get("USINFO").cine_name,
          cinema_id: authenticationService.get("USINFO").cinema_id,
          customer_id: store.getters.cust_id,
          fnb_items: store.getters.SelectedFnbItemList || []
        };
        MarketingService.AddOfferVoucherLogsV2(objPayload)
          .then(async response => {
            const { data } = response;
            if (data && data.status) {
              
              if(offer && offer.offer_type_id == 3) {
                if (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "Y" && offer.oc_is_combo_with_fnb == "Y") {
                  let array = store.getters.SelectedFnbItemList.filter(singleItem => { return (singleItem.item_id == offer.oc_buy_item_id || singleItem.item_code == offer.oc_buy_item_code)  && singleItem.quantity >= offer.oc_buy_item_count });
                  let toBuyItem = store.getters.fnbItems.filter((x) => (x.item_id == offer.oc_buy_item_id || x.item_code == offer.oc_buy_item_code))
                  let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex(
                    fnbItem => (offer.oc_get_item_code && fnbItem.item_code == offer.oc_get_item_code) || fnbItem.item_id == offer.oc_get_item_id
                  );
                  let itemCount = 0;
                  store.getters.SelectedFnbItemList.forEach((x) => {
                    if((x.item_id == offer.oc_buy_item_id) || (x.item_code == offer.oc_buy_item_code)) {
                      itemCount+= x.quantity;
                    }
                  })

                  let totalFreeItemQty = 0;
                  if (
                    offer.oc_buy_item_count == offer.oc_get_item_count
                    && offer.oc_buy_item_count > 1
                  ) {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        itemCount /
                          parseInt(
                            offer.oc_buy_item_count +
                              offer.oc_get_item_count
                          )
                      ) * offer.oc_get_item_count
                    );
                  } else {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        itemCount / parseInt(offer.oc_buy_item_count)
                      ) * offer.oc_get_item_count
                    );
                  }
                  
                  if(array && array.length > 0) {
                    let offerFnbItem = store.getters.fnbItems.filter((x) => ((offer.oc_get_item_code && x.item_code == offer.oc_get_item_code) || x.item_id == offer.oc_get_item_id) && checkItemAvailable(x))
                    let getItemCount = 0
                    store.getters.SelectedFnbItemList.forEach((x) => {
                      if(x.item_id == offer.oc_get_item_id || offer.oc_get_item_code == x.item_code) {
                        getItemCount+= x.quantity;
                      }
                    })
                    if (offerFnbItem.length > 0) {
                      console.log('totalFreeItemQty', totalFreeItemQty);
                      offerFnbItem[0]["quantity"] = totalFreeItemQty ? totalFreeItemQty : 1;
                      offerFnbItem[0]["add_custom_quantity"] = 'Y';
                      await store.dispatch("onAddFnBList", offerFnbItem[0]);
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                      vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                    } else {
                      await dispatch("onResetOffersAndPrice");
                      console.log('COMING IN ELSE WHEN NO ITEM FOUND FOR OFFER *****');
                      Vue.toasted.show(
                        "FNB item Not Found"
                      );
                      console.log('COMING IN ELSE TO DO NOTHING');
                    }

                  } else {
                    console.log('COMING IN FALSE');
                    let offerFnbItem = store.getters.fnbItems.filter((x) => (offer.oc_get_item_code && x.item_code == offer.oc_get_item_code) || x.item_id == offer.oc_get_item_id)
                    if (offerFnbItem.length > 0 && offerFnbItemIndex > 0) {
                        await store.dispatch('onRemoveFnBList', { index: offerFnbItemIndex })
                    } else {
                        await dispatch('onResetOffersAndPrice')
                        let toastMsg = 'Offer not applicable on selected items'
                        if(toBuyItem.length > 0) {
                          toastMsg = "Please select atleast " + offer.oc_buy_item_count + ' of ' + toBuyItem[0].item_name
                        }
                        Vue.toasted.show(toastMsg);
                    }
                    let msg = `Offer not applicable on selected items`
                    if(toBuyItem && toBuyItem.length > 0) {
                      msg = 'Offer is applicable on puchasing' + offer.oc_buy_item_count + ' ' + toBuyItem[0].item_name
                    }

                    console.log('msg', msg);
                    Vue.toasted.show(msg)
                  }
                
                } else if (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "N" && offer.oc_is_combo_with_fnb == "Y") {
                  let array = store.getters.SelectedFnbItemList.filter(singleItem => { return ((singleItem.item_id == offer.oc_buy_item_id) || (singleItem.item_code == offer.oc_buy_item_code))  && singleItem.quantity >= offer.oc_buy_item_count });
                  let toBuyItem = store.getters.fnbItems.filter((x) => x.item_id == offer.oc_buy_item_id)
                  let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex(
                    fnbItem => (offer.oc_get_item_code && fnbItem.item_code == offer.oc_get_item_code) || fnbItem.item_id == offer.oc_get_item_id
                  );
                  let itemCount = 0;
                  store.getters.SelectedFnbItemList.forEach((x) => {
                    if(x.item_id == offer.oc_buy_item_id || x.item_code == offer.oc_buy_item_code) {
                      itemCount+= x.quantity;
                    }
                  })

                  let totalFreeItemQty = 0;
                  if (
                    offer.oc_buy_item_count == offer.oc_get_item_count
                    && offer.oc_buy_item_count > 1
                  ) {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        itemCount /
                          parseInt(
                            offer.oc_buy_item_count +
                              offer.oc_get_item_count
                          )
                      ) * offer.oc_get_item_count
                    );
                  } else {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        itemCount / parseInt(offer.oc_buy_item_count)
                      ) * offer.oc_get_item_count
                    );
                  }
                  
                  if(array && array.length > 0) {
                    let offerFnbItem = store.getters.fnbItems.filter((x) => ((offer.oc_get_item_code && x.item_code == offer.oc_get_item_code) || x.item_id == offer.oc_get_item_id) && checkItemAvailable(x))
                    let getItemCount = 0
                    store.getters.SelectedFnbItemList.forEach((x) => {
                      if(x.item_id == offer.oc_get_item_id || x.item_code == offer.oc_get_item_code) {
                        getItemCount+= x.quantity;
                      }
                    })
                    if (offerFnbItem.length > 0) {
                      offerFnbItem[0]["quantity"] = totalFreeItemQty ? totalFreeItemQty : 1;
                      offerFnbItem[0]["add_custom_quantity"] = 'Y';
                      await store.dispatch("onAddFnBList", offerFnbItem[0]);
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                      vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                    } else {
                      await dispatch("onResetOffersAndPrice");
                      Vue.toasted.show(
                        "FNB item Not Found"
                      );
                      console.log('COMING IN ELSE TO DO NOTHING');
                    }

                  } else {
                    console.log('COMING IN FALSE');
                    console.log('COMING IN FALSE');
                    let offerFnbItem = store.getters.fnbItems.filter((x) => (offer.oc_get_item_code && x.item_code == offer.oc_get_item_code) || x.item_id == offer.oc_get_item_id)
                    if (offerFnbItem.length > 0 && offerFnbItemIndex > 0) {
                        await store.dispatch('onRemoveFnBList', { index: offerFnbItemIndex })
                    } else {
                        await dispatch('onResetOffersAndPrice')
                        let toastMsg = 'Offer not applicable on selected items'
                        if(toBuyItem.length > 0) {
                          toastMsg = "Please select atleast " + offer.oc_buy_item_count + ' of ' + toBuyItem[0].item_name
                        }
                        Vue.toasted.show(toastMsg);
                    }
                    let msg = `Offer not applicable on selected items`
                    if(toBuyItem && toBuyItem.length > 0) {
                      msg = 'Offer is applicable on puchasing' + offer.oc_buy_item_count + ' ' + toBuyItem[0].item_name
                    }
                    Vue.toasted.show(msg)
                  }
                
                
                  if (
                    false &&
                    store.getters.SELECTED_SEATS.length >= offer.oc_buy_no_of_ticket
                  ) {
                    console.log("Offer20");
        
                    let offerFnbItem = store.getters.fnbItems.filter(fnbItem => {
                      return fnbItem.item_code == offer.item_code;
                    });
                    let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex(
                      fnbItem => fnbItem.item_code == offer.item_code
                    );
                    if (offerFnbItemIndex > -1) {
                      console.log("Offer21");
        
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                    } else if (offerFnbItem.length > 0) {
                      console.log("Offer22");
        
                      Vue.toasted.show(
                        "Please select " + offerFnbItem[0].item_name ||
                        offerFnbItem[0].recipe_name
                      );
                    } else {
                      console.log("Offer23");
        
                      Vue.toasted.show("Offer Not Applicable");
                      await dispatch("onResetOffersAndPrice");
                    }
                  } else if(false) {
                    console.log("Offer24");
        
                    await dispatch("onResetOffersAndPrice");
                    Vue.toasted.show(
                      "Please select atleast " +
                      offer.oc_buy_no_of_ticket +
                      " ticket(s)"
                    );
                  }
                }
              } else {
                console.log('APPLY OFFER AND PROMOTIONS ELSE');
                await commit("SET_SELECTED_OFFERS", payload);
                await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                Vue.toasted.show(data.message);
              }
            } else {
              Vue.toasted.show(data.message);
              await dispatch("onResetOffersAndPrice");
            }
          })
          .catch(error => {
            console.log('ERROR:', error);
            Vue.toasted.show("Catch Error on fetchOffersVouchersList", error);
          }).finally(() => {
            loader.hide();
          })
      }
    } else if (offerFor === "fnbVouchers") {
      if (String(state.voucherCode).length == 0) {
        Vue.toasted.show("Please Enter voucher code");
      } else if (
        false &&
        state.voucherCode != offer.voucher_code &&
        offer.is_code_required == "Y" &&
        !payload.hasOwnProperty("is_voucher_with_offers")
      ) {
        Vue.toasted.show("Voucher Not Exist");
      } else {
        let loader = Vue.$loading.show();
        MarketingService.VerifyVoucherCodeV2({
          voucher_code:
            String(state.voucherCode).length > 0
              ? state.voucherCode
              : offer.hasMultiple == "N"
                ? offer.voucher_code
                : "",
          voucher_title: "_" + offer.voucher_title,
          isTicket: false,
          net_amount: store.getters.selectedFnBItemsTotalPrice,
          total_amount:
            store.getters.selectedFnBItemsTotalPrice +
            store.getters.TotalAdditionalTaxes +
            store.getters.customizationTotalPrice,
          cinema_name: authenticationService.get("USINFO").cine_name,
          cinema_id: authenticationService.get("USINFO").cinema_id,
          customer_id: store.getters.cust_id,
          fnb_items: store.getters.SelectedFnbItemList || [],
          checkSpecificTitle: checkSpecificTitle,
        }).then(async response => {
          const { data } = response;
          if (data && data.status) {
            let Voucherobj = {
              offer: data.Records[0],
              offerFor: offerFor
            };
            offer = data.Records[0];
            commit("SET_TEMP_OFFER_DATA", offer);
            if (data.hasOwnProperty("isOpenVoucher") && data.isOpenVoucher) {
              await commit("SET_OPEN_VOUCHER_INFO", data);
              if (
                data.hasOwnProperty("isComplementary") &&
                !data.isComplementary &&
                !data.ticketTypeId
              ) {
                vmVue.$root.$emit("bv::show::modal", "total_discount_popup");
                vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
                vmVue.$root.$emit("bv::hide::modal", "verifyVoucherFnb");

                //show a popup with a number field to enter amount not gretor then total amount of ticket type * ticket type count
              } else {
                Vue.toasted.show("Something Went Wrong!");
              }
            } else {
              await commit("SET_SELECTED_OFFERS", Voucherobj);
              await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
              vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
              vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
              vmVue.$root.$emit("bv::hide::modal", "verifyVoucherFnb");

              Vue.toasted.show(data.message);
            }
          } else {
            await dispatch("onResetOffersAndPrice");
            Vue.toasted.show(data.message);
          }
        }).catch(async error => {
          await dispatch("onResetOffersAndPrice");
          await dispatch("ResetVoucherCode");
          Vue.toasted.show("Catch Error on Voucher", error.message);
        }).finally(() => {
          loader.hide()
        })
      }
    }else if (offerFor === "BoxOfficeFnbVouchers") {
      if (String(state.voucherCode).length == 0) {
        Vue.toasted.show("Please Enter voucher code");
      } else {
        console.log("state.voucherCode", state.voucherCode);
        let loader = Vue.$loading.show();
        MarketingService.VerifyVoucherCodeV2({
          voucher_code:
            String(state.voucherCode).length > 0
              ? state.voucherCode
              : offer.hasMultiple == "N"
                ? offer.voucher_code
                : "",
          isComboApplied: true,
          fnb_net_amount:
            store.getters.selectedFnBItemsTotalPrice +
            store.getters.customizationTotalPrice,
          fnb_total_amount:
            store.getters.selectedFnBItemsTotalPrice +
            store.getters.TotalAdditionalTaxes +
            store.getters.customizationTotalPrice,
          fnb_total_item: store.getters.SelectedFnbItemList.length,
          voucher_title: state.voucherCode,
          total_amount: parseFloat(store.getters.TOTAL_AMOUNT) - parseFloat(store.getters.RateCardAddonsChargesFinalAmount|| 0),
          net_amount: store.getters.NET_AMOUNT,
          cinema_id: authenticationService.get("USINFO").cinema_id,
          md_id: store.getters.getMovieDetailsId,
          isTicket: true,
          cinema_name: authenticationService.get("USINFO").cine_name,
          total_ticket: store.getters.SELECTED_SEATS.length,
          customer_id: store.getters.cust_id,
          reservation_id: store.getters.reservationId,
          fnb_items: store.getters.SelectedFnbItemList || []
        })
          .then(async response => {
            const { data } = response;
            console.log("data", data);
            if (data && data.status) {
              console.log("data inner", data);
              let Voucherobj = {
                offer: data.Records[0],
                offerFor: offerFor
              };
              offer = data.Records[0];
              commit("SET_TEMP_OFFER_DATA", offer);
              if (data.hasOwnProperty("isOpenVoucher") && data.isOpenVoucher) {
                await commit("SET_OPEN_VOUCHER_INFO", data);
                if (
                  data.hasOwnProperty("isComplementary") &&
                  !data.isComplementary &&
                  !data.ticketTypeId
                ) {
                  vmVue.$root.$emit("bv::show::modal", "total_discount_popup");
                  vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
                  vmVue.$root.$emit("bv::hide::modal", "verifyVoucherFnb");
  
                  //show a popup with a number field to enter amount not gretor then total amount of ticket type * ticket type count
                } else {
                  Vue.toasted.show("Something Went Wrong!");
                }
              } else{
                await commit("SET_SELECTED_VOUCHER", Voucherobj);
                await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                console.log("data inner 2", data);
                vmVue.$root.$emit("bv::hide::modal", "verifyBOXFNBVoucher");
                Vue.toasted.show(data.message);

              }
          
            } else {
              await dispatch("onResetOffersAndPrice");
              await dispatch("ResetVoucherCode");
              Vue.toasted.show(data.message);
            }
          })
          .catch(async error => {
            Vue.toasted.show("Catch Error on Voucher", error.message);
            await dispatch("onResetOffersAndPrice");
            await dispatch("ResetVoucherCode");
          }).finally(() => {
            loader.hide();
          })
      }
    }
  },

  applyBoxOfficeFnbOffersHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    const { event, offerFor } = payload;
    let checkSpecificTitle = payload.hasOwnProperty('checkSpecificTitle') ? payload.checkSpecificTitle : 'N'
    let offer = payload.offer;
    let cinema_id = authenticationService.get("USINFO").cinema_id;
    await store.dispatch("resetLoyaltyData");
    if (offerFor === "BoxOfficeFnbOffers") {
      console.log("Offer1");
      let loader = Vue.$loading.show();
      let objPayload = {
        oc_id: offer.oc_id,
        total_amount: parseFloat(store.getters.TOTAL_AMOUNT) - parseFloat(store.getters.RateCardAddonsChargesFinalAmount|| 0),
        net_amount: store.getters.NET_AMOUNT,
        cinema_id: cinema_id,
        md_id: store.getters.getMovieDetailsId,
        isTicket: true,
        reservation_id: store.getters.reservationId,
        cinema_name: authenticationService.get("USINFO").cine_name,
        total_ticket: store.getters.SELECTED_SEATS.length,
        ss_start_show_time: store.getters.SHOW_DETAILS.ss_start_show_time,
        customer_id: store.getters.cust_id,
        fnb_items: store.getters.SelectedFnbItemList || []
      };
      MarketingService.AddOfferVoucherLogsV2(objPayload).then(async (response) => {
        const { data } = response;
          if (data && data.status) {
            offer = data.Records[0];
            if (offer.offer_type_id == 6) {
              console.log("Offer2");
      
              if (
               (offer.offer_redeem_at_boxoffice == "Y" &&
                offer.offer_redeem_at_concession == "Y") || offer.offer_redeem_at_boxoffice == "Y"
              ) {
                console.log("Offer3");
      
                let totalPrice =
                  store.getters.selectedFnBItemsTotalPrice +
                  store.getters.TotalAdditionalTaxes +
                  store.getters.TOTAL_AMOUNT;
                if (state.promocode && state.promocode.length > 0) {
                  console.log("Offer4");
      
                  if (offer.promo_code == state.promocode) {
                    console.log("Offer5");
      
                    if (totalPrice >= offer.pcs_min_ticket_amount) {
                      console.log("Offer6");
      
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                      vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                    } else {
                      console.log("Offer7");
      
                      Vue.toasted.show(
                        "Minimum ticket price should be " +
                        offer.pcs_min_ticket_amount
                      );
                      await dispatch("onResetOffersAndPrice");
                    }
                  } else {
                    console.log("Offer8");
      
                    Vue.toasted.show("Not a valid promocode");
                    await dispatch("onResetOffersAndPrice");
                  }
                } else {
                  console.log("Offer9");
      
                  Vue.toasted.show("Please Enter Promocode");
                  await dispatch("onResetOffersAndPrice");
                }
              } else {
                Vue.toasted.show("Offer Not Applicable");
                await dispatch("onResetOffersAndPrice");
              }
            } else {
              console.log("Offer10");
      
              if(offer && offer.offer_type_id == 3) {
                if (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "Y" && offer.oc_is_combo_with_fnb == "N") {
                  let TotalSeats = store.getters.SELECTED_SEATS.length || 0;
                  if (
                    store.getters.SELECTED_SEATS.length >= offer.oc_buy_no_of_ticket
                  ) {
                    console.log("Offer12", store.getters.fnbItems);
                    console.log('offer.oc_get_item_code', offer.oc_get_item_code, offer.item_code);
        
                    let offerFnbItem = store.getters.fnbItems.filter((x) => ((offer.oc_get_item_code && (x.item_code == offer.oc_get_item_code)) || offer.oc_get_item_id == x.item_id) && checkItemAvailable(x))
        
                    console.log("offerFnbItem", offerFnbItem);
        
                    let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex((x) => (offer.oc_get_item_code && (x.item_code == offer.oc_get_item_code)) || offer.oc_get_item_id == x.item_id)
                    let getItemCount = 0
                    store.getters.SelectedFnbItemList.forEach((x) => {
                      if(x.item_id == offer.oc_get_item_id || x.item_code == offer.oc_get_item_code) {
                        getItemCount+= x.quantity;
                      }
                    })
                    let totalFreeItemQty = 0;
                    if (
                      offer.oc_buy_no_of_ticket == offer.oc_get_item_count
                      && offer.oc_buy_item_count > 1
                    ) {
                      totalFreeItemQty = parseInt(
                        Math.floor(
                          TotalSeats /
                            parseInt(
                              offer.oc_buy_no_of_ticket +
                                offer.oc_get_item_count
                            )
                        ) * offer.oc_get_item_count
                      );
                    } else {
                      totalFreeItemQty = parseInt(
                        Math.floor(
                          TotalSeats / parseInt(offer.oc_buy_no_of_ticket)
                        ) * offer.oc_get_item_count
                      );
                    }

                    console.log('totalFreeItemQty', totalFreeItemQty);
      
                    if (offerFnbItem.length > 0) {
                      offerFnbItem[0]["quantity"] = totalFreeItemQty ? totalFreeItemQty : 1;
                      offerFnbItem[0]["add_custom_quantity"] = 'Y';
                      await store.dispatch("onAddFnBList", offerFnbItem[0]);
      
                      let fnbObj = {
                        ...offerFnbItem[0],
                        quantity: totalFreeItemQty || 1,
                        item_is_compulsory: "Y",
                        is_package_ticket: "Y"
                      };
                      let additionalPayload = {
                        ...payload,
                        item_id: offerFnbItem[0].item_id
                      }
                      await store.dispatch("addFnbItemFromBoxOffice", fnbObj);
                      await store.dispatch("fetchFnBAdditionalPrice", additionalPayload);
      
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                      // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                      vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                    } else {
                      await dispatch("onResetOffersAndPrice");
                      Vue.toasted.show(
                        "FNB item Not Found"
                      );
                    }
                  } else {
                    await dispatch("onResetOffersAndPrice");
                    Vue.toasted.show(
                      "Please select atleast " +
                      offer.oc_buy_no_of_ticket +
                      " ticket(s)"
                    );
                  }
                
                } else if (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "N" && offer.oc_is_combo_with_fnb == "N") {
      
                  let TotalSeats = store.getters.SELECTED_SEATS.length || 0;
                  if (
                    store.getters.SELECTED_SEATS.length >= offer.oc_buy_no_of_ticket
                  ) {
                    console.log("Offer12", store.getters.fnbItems);
                    console.log('offer.oc_get_item_code', offer.oc_get_item_code, offer.item_code);
        
                    let offerFnbItem = store.getters.fnbItems.filter((x) => ((offer.oc_get_item_code && (x.item_code == offer.oc_get_item_code)) || offer.oc_get_item_id == x.item_id) && checkItemAvailable(x))
        
                    console.log("offerFnbItem", offerFnbItem);
        
                    let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex((x) => (offer.oc_get_item_code && (x.item_code == offer.oc_get_item_code)) || offer.oc_get_item_id == x.item_id)
                    let getItemCount = 0
                    store.getters.SelectedFnbItemList.forEach((x) => {
                      if(x.item_id == offer.oc_get_item_id || x.item_code == offer.oc_get_item_code) {
                        getItemCount+= x.quantity;
                      }
                    })
                    let totalFreeItemQty = 0;
                    if (
                      offer.oc_buy_no_of_ticket == offer.oc_get_item_count
                      && offer.oc_buy_item_count > 1
                    ) {
                      totalFreeItemQty = parseInt(
                        Math.floor(
                          TotalSeats /
                            parseInt(
                              offer.oc_buy_no_of_ticket +
                                offer.oc_get_item_count
                            )
                        ) * offer.oc_get_item_count
                      );
                    } else {
                      totalFreeItemQty = parseInt(
                        Math.floor(
                          TotalSeats / parseInt(offer.oc_buy_no_of_ticket)
                        ) * offer.oc_get_item_count
                      );
                    }
                    console.log('totalFreeItemQty', totalFreeItemQty);
      
                    if (offerFnbItem.length > 0) {
                      offerFnbItem[0]["quantity"] = totalFreeItemQty ? totalFreeItemQty : 1;
                      offerFnbItem[0]["add_custom_quantity"] = 'Y';
                      await store.dispatch("onAddFnBList", offerFnbItem[0]);
                      
                      let fnbObj = {
                        ...offerFnbItem[0],
                        quantity: totalFreeItemQty || 1,
                        item_is_compulsory: "Y",
                        is_package_ticket: "Y"
                      };
      
                      let additionalPayload = {
                        ...payload,
                        item_id: offerFnbItem[0].item_id
                      }
                      await store.dispatch("addFnbItemFromBoxOffice", fnbObj);
                      await store.dispatch("fetchFnBAdditionalPrice", additionalPayload);
      
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                      // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                      vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                    } else {
                      await dispatch("onResetOffersAndPrice");
                      Vue.toasted.show(
                        "FNB item Not Found"
                      );
                    }
                  } else {
                    await dispatch("onResetOffersAndPrice");
                    Vue.toasted.show(
                      "Please select atleast " +
                      offer.oc_buy_no_of_ticket +
                      " ticket(s)"
                    );
                  }
              
                } else if (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "Y" && offer.oc_is_combo_with_fnb == "Y") {
                  let array = store.getters.SelectedFnbItemList.filter(singleItem => { return (singleItem.item_id == offer.oc_buy_item_id || singleItem.item_code == offer.oc_buy_item_code) && singleItem.quantity >= offer.oc_buy_item_count });
                  let toBuyItem = store.getters.fnbItems.filter((x) => (x.item_id == offer.oc_buy_item_id || x.item_code == offer.oc_buy_item_code))
                  let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex(
                    fnbItem => (offer.oc_get_item_code && fnbItem.item_code == offer.oc_get_item_code) || fnbItem.item_id == offer.oc_get_item_id
                  );
                  let itemCount = 0;
                  store.getters.SelectedFnbItemList.forEach((x) => {
                    if(x.item_id == offer.oc_buy_item_id || x.item_code == offer.oc_buy_item_code) {
                      itemCount+= x.quantity;
                    }
                  })
      
                  let totalFreeItemQty = 0;
                  if (
                    offer.oc_buy_item_count == offer.oc_get_item_count
                    && offer.oc_buy_item_count > 1
                  ) {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        itemCount /
                          parseInt(
                            offer.oc_buy_item_count +
                              offer.oc_get_item_count
                          )
                      ) * offer.oc_get_item_count
                    );
                  } else {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        itemCount / parseInt(offer.oc_buy_item_count)
                      ) * offer.oc_get_item_count
                    );
                  }

                  console.log('totalFreeItemQty', totalFreeItemQty);
                  
                  if(array && array.length > 0) {
                    let offerFnbItem = store.getters.fnbItems.filter((x) => ((offer.oc_get_item_code && x.item_code == offer.oc_get_item_code) || x.item_id == offer.oc_get_item_id) && checkItemAvailable(x))
                    let getItemCount = 0
                    store.getters.SelectedFnbItemList.forEach((x) => {
                      if(x.item_id == offer.oc_get_item_id || x.item_code == offer.oc_get_item_code) {
                        getItemCount+= x.quantity;
                      }
                    })
                    if (offerFnbItem.length > 0) {
                      console.log('totalFreeItemQty', totalFreeItemQty);
                      offerFnbItem[0]["quantity"] = totalFreeItemQty ? totalFreeItemQty : 1;
                      offerFnbItem[0]["add_custom_quantity"] = 'Y';
                      await store.dispatch("onAddFnBList", offerFnbItem[0]);
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                      // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                      vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                    } else {
                      await dispatch("onResetOffersAndPrice");
                      Vue.toasted.show(
                        "FNB item Not Found"
                      );
                      console.log('COMING IN ELSE TO DO NOTHING');
                    }
      
                  } else {
                    console.log('COMING IN FALSE');
                    let offerFnbItem = store.getters.fnbItems.filter((x) => (offer.oc_get_item_code && x.item_code == offer.oc_get_item_code) || x.item_id == offer.oc_get_item_id)
                    if (offerFnbItem.length > 0 && offerFnbItemIndex > 0) {
                        await store.dispatch('onRemoveFnBList', { index: offerFnbItemIndex })
                    } else {
                        await dispatch('onResetOffersAndPrice')
                        let toastMsg = 'Offer not applicable on selected items'
                        if(toBuyItem.length > 0) {
                          toastMsg = "Please select atleast " + offer.oc_buy_item_count + ' of ' + toBuyItem[0].item_name
                        }
                        Vue.toasted.show(toastMsg);
                    }
                    let msg = `Offer not applicable on selected items`
                    if(toBuyItem && toBuyItem.length > 0) {
                      msg = 'Offer is applicable on puchasing' + offer.oc_buy_item_count + ' ' + toBuyItem[0].item_name
                    }
                    Vue.toasted.show(msg)
                  }
                
                } else if (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "N" && offer.oc_is_combo_with_fnb == "Y") {
                  let array = store.getters.SelectedFnbItemList.filter(singleItem => { return (singleItem.item_id == offer.oc_buy_item_id || singleItem.item_code == offer.oc_buy_item_code) && singleItem.quantity >= offer.oc_buy_item_count });
                  let toBuyItem = store.getters.fnbItems.filter((x) => x.item_id == offer.oc_buy_item_id || x.item_code == offer.oc_buy_item_code)
                  let offerFnbItemIndex = store.getters.SelectedFnbItemList.findIndex(
                    fnbItem => (offer.oc_get_item_code && fnbItem.item_code == offer.oc_get_item_code) || fnbItem.item_id == offer.oc_get_item_id
                  );
                  let itemCount = 0;
                  store.getters.SelectedFnbItemList.forEach((x) => {
                    if(x.item_id == offer.oc_buy_item_id || x.item_code == offer.oc_buy_item_code) {
                      itemCount+= x.quantity;
                    }
                  })
      
                  let totalFreeItemQty = 0;
                  if (
                    offer.oc_buy_item_count == offer.oc_get_item_count
                    && offer.oc_buy_item_count > 1
                  ) {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        itemCount /
                          parseInt(
                            offer.oc_buy_item_count +
                              offer.oc_get_item_count
                          )
                      ) * offer.oc_get_item_count
                    );
                  } else {
                    totalFreeItemQty = parseInt(
                      Math.floor(
                        itemCount / parseInt(offer.oc_buy_item_count)
                      ) * offer.oc_get_item_count
                    );
                  }
                  
                  if(array && array.length > 0) {
                    let offerFnbItem = store.getters.fnbItems.filter((x) => ((offer.oc_get_item_code && x.item_code == offer.oc_get_item_code) || x.item_id == offer.oc_get_item_id) && checkItemAvailable(x))
                    let getItemCount = 0
                    store.getters.SelectedFnbItemList.forEach((x) => {
                      if(x.item_id == offer.oc_get_item_id || x.item_code == offer.oc_get_item_code) {
                        getItemCount+= x.quantity;
                      }
                    })
                    console.log('totalFreeItemQty', totalFreeItemQty);
                    if (offerFnbItem.length > 0) {
                      offerFnbItem[0]["quantity"] = totalFreeItemQty ? totalFreeItemQty : 1;
                      offerFnbItem[0]["add_custom_quantity"] = 'Y';
                      await store.dispatch("onAddFnBList", offerFnbItem[0]);
                      await commit("SET_SELECTED_OFFERS", payload);
                      await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                      // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                      vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                      vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                    } else {
                      await dispatch("onResetOffersAndPrice");
                      Vue.toasted.show(
                        "FNB item Not Found"
                      );
                      console.log('COMING IN ELSE TO DO NOTHING');
                    }
      
                  } else {
                    console.log('COMING IN FALSE');
                    let offerFnbItem = store.getters.fnbItems.filter((x) => (offer.oc_get_item_code && x.item_code == offer.oc_get_item_code) || x.item_id == offer.oc_get_item_id)
                    if (offerFnbItem.length > 0 && offerFnbItemIndex > 0) {
                        await store.dispatch('onRemoveFnBList', { index: offerFnbItemIndex })
                    } else {
                        await dispatch('onResetOffersAndPrice')
                        let toastMsg = 'Offer not applicable on selected items'
                        if(toBuyItem.length > 0) {
                          toastMsg = "Please select atleast " + offer.oc_buy_item_count + ' of ' + toBuyItem[0].item_name
                        }
                        Vue.toasted.show(toastMsg);
                    }
                    let msg = `Offer not applicable on selected items`
                    if(toBuyItem && toBuyItem.length > 0) {
                      msg = 'Offer is applicable on puchasing' + offer.oc_buy_item_count + ' ' + toBuyItem[0].item_name
                    }
                    Vue.toasted.show(msg)
                  }
                }
              } else if (offer.offer_type_id == 2) {
                console.log(
                  " offer.oc_buy_no_of_ticket :>> ",
                  offer.oc_buy_no_of_ticket
                );
                console.log(
                  "store.getters.SelectedFnbItemList.length",
                  store.getters.SelectedFnbItemList.length
                );
                if (
                  (store.getters.SELECTED_SEATS.length + store.getters.SelectedFnbItemList.length) >=
                  offer.oc_buy_no_of_ticket
                ) {
                  console.log("Offer262");
      
                  await commit("SET_SELECTED_OFFERS", payload);
                   await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                  // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                  vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                  vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                } else {
                  console.log("OFFER 26");
                  Vue.toasted.show(
                    `Please select atleast ${offer.oc_buy_no_of_ticket} items.`
                  );
                }
              } else if(offer.offer_type_id == 7) { 
                await commit("SET_SELECTED_OFFERS", payload);
                await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
              } else if(offer.offer_type_id == 8){ 
                await commit("SET_SELECTED_OFFERS", payload);
                await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
              } else if(offer && offer.offer_type_id == 9) {
                let TotalSeats = store.getters.SELECTED_SEATS.length || 0;
                let totalTicketOffer = 0;
                totalTicketOffer = parseInt(
                  Math.floor(
                    TotalSeats / parseInt(offer.oc_buy_no_of_ticket)
                  )
                );
  
                if (
                  offer.oc_max_no_of_ticket_per_transaction &&
                  totalTicketOffer > offer.oc_max_no_of_ticket_per_transaction &&
                  offer.oc_max_no_of_ticket_per_transaction > 0
                ) {
                  totalTicketOffer = offer.oc_max_no_of_ticket_per_transaction;
                }
  
                if (store.getters.SELECTED_SEATS.length >= offer.oc_buy_no_of_ticket) {
                  if(offer.oc_is_combo_with_fnb == "Y") {
                    let fnbItemsArray = offer.fnb_group_data || [];
                    let errorCount = 0;
                    for(let i=0; i<fnbItemsArray.length; i++) {
                    let itemObj = fnbItemsArray[i];
                      console.log('itemObj', itemObj);
                      let offerFnbItem = store.getters.fnbItems.filter((x) => (((x.item_code == itemObj.oc_buy_item_code)) || itemObj.oc_buy_item_id == x.item_id) && checkItemAvailable(x))
                      if (offerFnbItem.length > 0) {
  
                        offerFnbItem[0]["quantity"] = parseInt(itemObj.oc_buy_no_of_item || 1) * parseInt(totalTicketOffer || 1);
  
                        offerFnbItem[0]["add_custom_quantity"] = 'Y';
  
                        await store.dispatch("onAddFnBList", offerFnbItem[0]);
                        
                        let fnbObj = {
                          ...offerFnbItem[0],
                          quantity: parseInt(itemObj.oc_buy_no_of_item || 1) * parseInt(totalTicketOffer || 1),
                          item_is_compulsory: "Y",
                          is_package_ticket: "Y"
                        };
    
                        let additionalPayload = {
                          ...payload,
                          item_id: offerFnbItem[0].item_id
                        }
  
                        await store.dispatch("addFnbItemFromBoxOffice", fnbObj);
                        await store.dispatch("fetchFnBAdditionalPrice", additionalPayload);
    
                        await commit("SET_SELECTED_OFFERS", payload);
                        await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                        // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                        vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                        vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");

                        console.log('store.getters.SelectedFnbItemList', store.getters.SelectedFnbItemList);
                      } else {
                        errorCount++;
                      }
                    }
                    if(errorCount > 0) {
                      await dispatch("onResetOffersAndPrice");
                      await store.commit("REMOVE_SELECTED_FNB_ITEMS");
                      Vue.toasted.show(
                        "FNB item Not Found"
                      );
                    }
                  } else {
                    await commit("SET_SELECTED_OFFERS", payload);
                    await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                    // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                    vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                    vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
                  }
                } else {
                  await dispatch("onResetOffersAndPrice");
                    Vue.toasted.show(
                      "Please select atleast " +
                      offer.oc_buy_no_of_ticket +
                      " ticket(s)"
                    );
                }
              } else if(offer && offer.offer_type_id == 10) {
                await commit("SET_SELECTED_OFFERS", payload);
                await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
              } else if(offer && offer.offer_type_id == 1) {
                await commit("SET_SELECTED_OFFERS", payload);
                await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                // await commit("CALCULATE_BOX_OFFICE_FNB_OFFER_PRICE", offer);
                vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                vmVue.$root.$emit("bv::hide::modal", "promoOffersPopup");
              } else {
                console.log("Offer25");
                Vue.toasted.show("Offer Not Applicable");
                await dispatch("onResetOffersAndPrice");
              }
            }

          } else {

          }

      }).catch((err) => {

      }).finally(() => {
        loader.hide()
      })
    } else if (offerFor === "BoxOfficeFnbVouchers") {
      if (String(state.voucherCode).length == 0) {
        Vue.toasted.show("Please Enter voucher code");
      } else {
        console.log("state.voucherCode", state.voucherCode);
        let loader = Vue.$loading.show();
        MarketingService.VerifyVoucherCodeV2({
          voucher_code:
            String(state.voucherCode).length > 0
              ? state.voucherCode
              : offer.hasMultiple == "N"
                ? offer.voucher_code
                : "",
          isComboApplied: true,
          fnb_net_amount:
            store.getters.selectedFnBItemsTotalPrice +
            store.getters.customizationTotalPrice,
          fnb_total_amount:
            store.getters.selectedFnBItemsTotalPrice +
            store.getters.TotalAdditionalTaxes +
            store.getters.customizationTotalPrice,
          fnb_total_item: store.getters.SelectedFnbItemList.length,
          voucher_title: offer.voucher_title || state.voucherCode,
          total_amount: parseFloat(store.getters.TOTAL_AMOUNT) - parseFloat(store.getters.RateCardAddonsChargesFinalAmount|| 0),
          net_amount: store.getters.NET_AMOUNT,
          cinema_id: authenticationService.get("USINFO").cinema_id,
          md_id: store.getters.getMovieDetailsId,
          isTicket: true,
          reservation_id: store.getters.reservationId,
          cinema_name: authenticationService.get("USINFO").cine_name,
          total_ticket: store.getters.SELECTED_SEATS.length,
          customer_id: store.getters.cust_id,
          fnb_items: store.getters.SelectedFnbItemList || [],
          checkSpecificTitle: checkSpecificTitle
        })
          .then(async response => {
            const { data } = response;
            console.log("data", data);
            if (data && data.status) {
              console.log("data inner", data);
              let Voucherobj = {
                offer: data.Records[0],
                offerFor: offerFor
              };
              offer = data.Records[0];
              commit("SET_TEMP_OFFER_DATA", offer);
              if (data.hasOwnProperty("isOpenVoucher") && data.isOpenVoucher) {
                await commit("SET_OPEN_VOUCHER_INFO", data);
                if (
                  data.hasOwnProperty("isComplementary") &&
                  !data.isComplementary &&
                  !data.ticketTypeId
                ) {
                  vmVue.$root.$emit("bv::show::modal", "total_discount_popup");
                  vmVue.$root.$emit("bv::hide::modal", "verifyVoucher");
                  vmVue.$root.$emit("bv::hide::modal", "verifyVoucherFnb");
  
                  //show a popup with a number field to enter amount not gretor then total amount of ticket type * ticket type count
                } else {
                  Vue.toasted.show("Something Went Wrong!");
                }
              } else{
                await commit("SET_SELECTED_VOUCHER", Voucherobj);
                await commit("SET_OFFER_VOUCHER_PRICE", data.BoxOffice);
                vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
                console.log("data inner 2", data);
                vmVue.$root.$emit("bv::hide::modal", "verifyBOXFNBVoucher");
                Vue.toasted.show(data.message);

              }
          
            } else {
              await dispatch("onResetOffersAndPrice");
              await dispatch("ResetVoucherCode");
              Vue.toasted.show(data.message);
            }
          })
          .catch(async error => {
            Vue.toasted.show("Catch Error on Voucher", error.message);
            await dispatch("onResetOffersAndPrice");
            await dispatch("ResetVoucherCode");
          }).finally(() => {
            loader.hide()
          })
      }
    }
  },
  // isOfferItemRemoved
  setOfferItemRemoveFlag: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_OFFER_ITEM_REMOVE_FLAG", payload);
  },
  addOfferVoucherLogs: async ({ dispatch, commit, state }, payload) => {
    MarketingService.AddOfferVoucherLogs(payload)
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          //
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on fetchOffersVouchersList", error);
      })
      .finally(() => { });
  }
};

const getters = {
  getOffersCollection: state => state.OffersList,
  getOffersVoucherCollection: state => state.OffersVoucherList,
  showViewOffers: state => state.offersPosFlags.isPosOffersShow,
  removeOfferItemFlag: state => state.offersPosFlags.isOfferItemRemoved,
  getCinemassettings: state => state.CinemaSettings,
  getOfferPrice: state => state.offerPrice,
  getSelectedOffer: state => state.selectedOffers,
  getOfferFor: state => state.offerFor,
  CardNumber: state => state.CardNumber,
  getVoucherCode: state => state.voucherCode,
  getVoucherComment: state => state.voucherComment,
  seatTypeArrayOpenVoucher: state => state.openVoucherSeatTypeArray,
  openVoucherTotalGrossAmount: state => state.openVoucher.totalGrossAmount,
  RemainingCashRefundOffer: state => state.RemainingCashRefundOffer,
  isOfferApplied: state => state.isOfferAppliedV2,
  tempOfferData: state => state.tempOfferData
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/PosOffersStore.js